import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Authorize from "../../utilities/Authorize";
import {
  Input,
  Dialog,
  ToggleButtonGroup,
  ToggleButton,
  ToggleSwitch,
  TabControl,
  TabItem,
  Dropdown,
  DropdownOption,
  NumericInput,
  Icon,
  Tooltip,
  WithTooltip,
  RadioGroup,
  RadioOption,
  Button
} from "@abb/abb-common-ux-react";

import SubmitHeader from "../shared/SubmitHeader";

import history from "../../utilities/History";

import testplanActions from "../../flux/actions/TestplanActions";
import testplanFormStore from "../../flux/stores/testplan/FormStore";

import instrumentActions from "../../flux/actions/InstrumentActions";
import instrumentListStore from "../../flux/stores/instrument/ListStore";

import propertyActions from "../../flux/actions/PropertyActions";
import propertyListStore from "../../flux/stores/property/ListStore";

import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";

import ITestplanFormData from "../../models/testplan/TestplanFormData";
import IFormComponent from "../../models/shared/FormComponent";
import {
  ITestPlanInstrument,
  InstrumentData,
} from "../../models/testplan/TestplanInstrument";
import {
  IKeyedInProperty,
  KeyedInProperty,
} from "../../models/testplan/TestplanKeyedIn";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import InputPosition from "./InputPosition";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import PositionBar from "./PositionBar";
import MeasuredPartition from "./MeasuredPartition";
import KeyedInPartition from "./KeyedInPartition";
import IDirectionData, {
  defaultDirectionData,
} from "../../models/direction/directionData";
import {
  IInstrumentPartition,
  ITestPlanDirection,
} from "../../models/testplan/InstrumentPartition";
import MeasuredEditablePartition from "./MeasuredEditablePartition";
import IPropertyType from "../../models/propertyType/PropertyTypeData";
import propertyTypeActions from "../../flux/actions/PropertyTypeActions";
import propertyTypeListStore from "../../flux/stores/propertyType/ListStore";
import { IKeyedInPartition } from "../../models/testplan/KeyedInPartition";
import directionActions from "../../flux/actions/DirectionAction";
import directionListStore from "../../flux/stores/direction/ListStore";
import KeyedInEditablePartition from "./KeyedInEditablePartition";
import { TestPlanScreen } from "../../utilities/Screen";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import { TestplanInstrumentOperations } from "../../models/testplan/TestplanInstrumentOperations";
import NoDataFound from "../shared/NoDataFound";
import { Translation } from "react-i18next";
import _, { constant, identity } from "lodash";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import measurementOrder from "../shared/MeasurementOrder";
import sourceActions from "../../flux/actions/SourceActions";
import sourceListStore from "../../flux/stores/source/ListStore";
import { ISourceViewData } from "../../models/source/SourceViewData";
import CalculatedProperty from "../../components/sharedNew/CalculatedProperty";
import calculatedPropertyActions from "../../flux/actions/CalculatedPropertyActions";
import { IPropertySpecification, PropertySpecification } from "../../models/shared/PropertySpecification";
import { ICalculatedPropertyViewData, IVariableData, IAttributeData, IPropertyData } from "../../models/property/CalculatedPropertyViewData";
import propertySelectedCalculatedIdStore from "../../flux/stores/property/BySelectedCalculatedIdStore";
import calculatedPropertyDetailsIdStore from "../../flux/stores/calculatedProperty/BySelectedIdStore";
import calculatedPropertySourceListStore from "../../flux/stores/calculatedProperty/ListStoreSource";
import calculatedPropertyValuesListStore from "../../flux/stores/calculatedProperty/ListStoreValues";
import IReading from "../../models/property/ReadingData";
import CalculatedPropertyViewData from "../../models/property/CalculatedPropertyViewData";
import instrumentSelectedIdStore from "../../flux/stores/instrument/BySelectedIdStore";
import propertySelectedIdStore from "../../flux/stores/property/BySelectedIdStore";
import FormulaDefinitionTable from "../../components/sharedNew/FormulaDefinitionTable";
import PropertySteps from "../../components/sharedNew/PropertySteps";
import PropertyTable from "../../components/sharedNew/PropertyTable";
import i18next from "i18next";
import gradeActions from "../../flux/actions/GradeActions";
import { ProductFormData } from "../../models/product/ProductFormData";
import { GradeBasicData } from "../../models/grade/GradeBasicData";
import productActions from "../../flux/actions/ProductActions";
import gradeFormStore from "../../flux/stores/grade/FormStore";
import partitionsDetailsListStore from "../../flux/stores/calculatedProperty/ListStorePartitions";
import { IGradeFormData } from "../../models/grade/GradeFormData";
import gradeListStore from "../../flux/stores/grade/ListStore";
import IdGenerator from "../../utilities/GenerateId";
import { IGradeViewData } from "../../models/grade/GradeViewData";


// Todo: Understand
type PropsType = RouteComponentProps & {
  editData: any;
  selectedInstruments: any;
  selectedKeyedInProperties: any;
};
// End

interface IFormState {
  testplanFormData: ITestplanFormData;
  modalVisibleInstrument: boolean;
  modalVisibleProperty: boolean;
  modalVisibleNumberOfPosition: boolean;
  title: string;
  selectedInstruments: any;
  instrumentPartitions: ITestPlanInstrument[];
  keyedInPartitions: IKeyedInProperty[];
  selectedKeyedInProperties: any[];
  selectedToggle: any[];
  activeTab: number;
  inputFixedPositionHandler: string;
  inputStripLengthHandler: string;
  inputNumberOfPositionHandler: string;
  inputPositionNameHandler: string;
  inputPositionWidthHandler: string;
  inputDirectionCountHandler: string;
  directions: IDirectionData[];
  sourceList: any[];
  selectedSource: any[];
  instrumentList: any[];
  keyedInPropertyList: any[];
  globalPositionInput: number;
  globalCountInput: number;
  globalStripLength: number;
  commonPosition: number;
  commonCount: number;
  isAllPositionsEqual: boolean;
  isAllCountsEqual: any;
  isAllStripLengthEqual: any;
  editGlobalValuesModalVisible: boolean;
  globalEditMode: string;
  isGlobalEditConfirm: boolean;
  editedInput: number;
  instrumentToBeRemoved: string;
  keyedInPropertyToBeRemoved: string;
  formLoading: boolean;
  nameError: boolean;
  allowclear: boolean;
  isSelectStripLength: any;
  calculatedPropertyDetails: ICalculatedPropertyViewData[];
  selectedCalculatedProperties: any;
  isNext: boolean;
  allCalculatedDropdownList: any;
  calculatedDropdownList: any[];
  disableValueDropdown: boolean;
  disablePositionDropdown: boolean;
  disableSourceDropdown: boolean;
  valueList: any[];
  readingSourceList: any[];
  readingValuesList: any[];
  isLoading: boolean;
  showthreshold: boolean;
  isStep: boolean;
  orderProperties: any[];
  gradeCodeError: boolean;
  gradeNameError: boolean;
  measuredProperty: any[];
  keyedInProperty: any[];
}

class Form
  extends React.Component<PropsType, IFormState>
  implements IFormComponent {
  private _mount: boolean;
  private _isReload: boolean;
  private _id: string;
  private _gradeId: string;
  private _messages: string[];
  private _gradeMessages: string[];
  private _keyedInPropertyType: IPropertyType;
  private _directionList: IDirectionData[];
  private _noDirection: IDirectionData;
  private _instrumentList: ITestPlanInstrument[] = [];
  private _keyedInPropertyList: IKeyedInProperty[] = [];
  private _sourceList: any[] = [];
  private _tempDropdownInstruments: any[] = [];
  private _tempDropdownKeyedIns: any[] = [];
  private _globalPosition: number;
  private _globalCOunt: number;
  private _calculatedPropertyDetails: ICalculatedPropertyViewData[] = [];
  private _fetchedCalculatedProperties: IPropertyViewData[] = [];
  private _readingSourceDropdown: IReading[] = [];
  private _readingValuesDropdown: IReading[] = [];
  private _testplanproperties: IPropertySpecification[] = [];
  private _partitionName: any[] = [];
  private _oldPartitionName: any[] = [];
  private _partitionListData: any;
  private _indexValueCount: number;
  private _fetchedInstruments: IInstrumentViewData[] = [];
  private _fetchedProperties: IPropertyViewData[] = [];
  private properties: IPropertySpecification[] = [];
  private allProperties: IPropertySpecification[] = [];
  private optionRef = React.createRef();
  private _readingSourceList: any[] = [];
  private _readingValuesList: any[] = [];
  private _indexSourceCount: number;
  private _indexPartitionCount: number;
  private _listData: any[];


  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as ITestplanFormData
    const measuredProperties = pushStateData?.properties?.filter((i: any) => i.isMeasured === true)
    const keyedInProperties = pushStateData?.properties?.filter((i: any) => i.isMeasured === false && i.isCalculated === false)
    this.state = {
      testplanFormData: pushStateData,
      modalVisibleInstrument: false,
      modalVisibleProperty: false,
      modalVisibleNumberOfPosition: false,
      title: "",
      selectedInstruments: pushStateData?.selectedInstruments || [],
      instrumentPartitions: pushStateData?.instruments || [],
      keyedInPartitions: pushStateData?.keyedIns || [],
      selectedKeyedInProperties: pushStateData?.selectedKeyedInProperties || [],
      activeTab: 0,
      selectedToggle: [0],
      inputFixedPositionHandler: "",
      inputStripLengthHandler: "10000",
      inputNumberOfPositionHandler: "1",
      inputPositionNameHandler: "",
      inputPositionWidthHandler: "",
      inputDirectionCountHandler: "",
      directions: [],
      selectedSource:
        pushStateData?.sourceId &&
          pushStateData.sourceId != CONSTANTS.DefaultGuid
          ? [{ value: pushStateData.sourceId, label: pushStateData.sourceId }]
          : [],
      sourceList: [],
      instrumentList: [],
      keyedInPropertyList: [],
      instrumentToBeRemoved: "",
      keyedInPropertyToBeRemoved: "",
      formLoading: false,
      nameError: false,
      globalPositionInput: 1,
      globalCountInput: 1,
      globalStripLength: 10000,
      commonPosition: 1,
      commonCount: 1,
      isAllPositionsEqual: true,
      isAllCountsEqual: true,
      isAllStripLengthEqual: true,
      editGlobalValuesModalVisible: false,
      globalEditMode: "",
      isGlobalEditConfirm: false,
      editedInput: 0,
      allowclear: false,
      calculatedPropertyDetails: [],
      disableValueDropdown: false,
      disablePositionDropdown: true,
      disableSourceDropdown: false,
      showthreshold: true,
      valueList: [],
      readingSourceList: [],
      readingValuesList: [],
      isLoading: false,
      isStep: false,
      orderProperties: [],
      selectedCalculatedProperties: Array.isArray(pushStateData?.calculatedProperties)
        && pushStateData?.calculatedProperties?.length !== 0
        ? pushStateData?.calculatedProperties?.map(
          (item: any) => ({
            value: item.propertyId,
            label: item.propertyName,
          })
        )
        : [],
      isNext: false,
      calculatedDropdownList: [],
      gradeCodeError: false,
      gradeNameError: false,
      measuredProperty: measuredProperties ? measuredProperties : [],
      keyedInProperty: keyedInProperties ? keyedInProperties : [],
      allCalculatedDropdownList: pushStateData
        ?.allCalculatedDropdownList?.length
        ? pushStateData?.allCalculatedDropdownList
        : [],
      isSelectStripLength:
        pushStateData?.sourceId &&
          pushStateData.sourceId != CONSTANTS.DefaultGuid
          ? true
          : false,
    };
    this._mount = false;
    this._noDirection = defaultDirectionData;
  }

  componentWillUnmount() {
    this._mount = false;
    document.removeEventListener("mousedown", this.onCloseAll);
  }

  componentDidMount() {
    this._mount = true;
    this._globalPosition = 1;
    this._globalCOunt = 1;
    if (this._mount) {
      document.addEventListener("mousedown", this.onCloseAll);
    }
    if (!this.state.testplanFormData?.isEditMode) {
      const stateData: any = this.props.history.location.state;
      if (stateData?.testplan?.id !== "") {
        const calculatedIds: string[] = [];
        this.state.testplanFormData.properties.map((id, index) => {
          calculatedIds.push(id.propertyId);
        });

        propertyActions.getSelectedCalculated(calculatedIds).then(() => {
          const calculatedDropdownList: any[] = [];
          this._fetchedCalculatedProperties.forEach(
            (element: IPropertyViewData) => {
              calculatedDropdownList.push({
                value: element.id,
                label: element.name,
              });
            }
          );

          const properties = this.state.testplanFormData.properties;
          const isCalculated = this.state.testplanFormData.properties.filter(
            (x) => x.isCalculated
          );
          if (isCalculated.length) {
            let arrItem: any[] = [];
            isCalculated.forEach((item: any) => {
              const value: any = {
                isNew: false,
                itemTemplate: undefined,
                label: item.propertyName,
                menuItemTemplate: undefined,
                selectedItemTemplate: undefined,
                value: item.propertyId,
              };
              arrItem.push(value);
            });
            this.calculateChangeHandler(arrItem);
          }

          this.setState(
            {
              testplanFormData: {
                ...this.state.testplanFormData,
                properties,
              },
              isNext: isCalculated.length ? true : false,
              calculatedDropdownList,
            },
            () => {
              this._testplanproperties = this.state.testplanFormData.allProperties;
            }
          );
        });
      }
      this.validate();
      // gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      //   if (this._mount) {
      //     this._listData = state.gradeDataList.result as IGradeViewData[];
      //     const copyCode: any = this.props.history.location.state
      //     const code = this._listData[0].code;
      //     const id = IdGenerator.incrementId(code);
      //     const idString = copyCode.gradeCode ? copyCode.gradeCode : id.toString()
  
      //     this.setState({
      //       testplanFormData: {
      //         ...this.state.testplanFormData,
      //         gradeCode: idString
      //       }
      //     });
      //   }
      // });

      // gradeActions
      // .getAll(
      //   false,
      //   1,
      //   CONSTANTS.PAGE_SIZE,
      //   CONSTANTS.SORT_CREATEDON,
      //   CONSTANTS.SORT_ORDER,
      //   ""
      // )
      // .then();
    }

    if (this.state.testplanFormData?.isEditMode) {
      const selectedCalculated: any[] = [];
      let calculatedPropertyDetails: ICalculatedPropertyViewData[] = [];
      let properties: IPropertySpecification[] = [];

      let isNext: boolean = false;
      if (Array.isArray(this.state.testplanFormData.selectedCalculatedProperty) &&
        this.state.testplanFormData.selectedCalculatedProperty.length > 0) {
        this.state.testplanFormData.selectedCalculatedProperty.map((data: any) => {
          const value = {
            label:
              data.property === undefined
                ? data.propertyName
                : data.property.name,
            value:
              data.property == undefined ? data.propertyId : data.property.id,
          };

          if (data.formulaMappings !== undefined) {
            let selectedSource: any[] = [];
            let selectedValue: any[] = [];
            let selectedPosition: string;
            let disablePosition = false;
            let disableValue = false;
            let disableSource = false;
            let id = "";
            let variable = "";
            let attribute: IAttributeData = { id: "", name: "" };
            let property: IPropertyData = {
              id: "",
              name: "",
              customId: "",
            };
            const variableMapData: IVariableData[] = [];
            data.formulaMappings[0].variableMapping.map(
              (variables: any, i: number) => {
                let randomNumber = Math.random();
                if (
                  variables.variableMapping?.source !== null &&
                  variables.variableMapping?.value !== null
                ) {
                  if (variables.attribute.name !== "Measured Property") {
                    disablePosition = true;
                    disableValue = true;
                    disableSource = true;
                  }
                  if (
                    variables.variableMapping?.source?.name === "Individual"
                  ) {
                    disablePosition = true;
                    disableValue = true;
                    selectedSource =
                      variables.variableMapping.source !== null
                        ? [
                          {
                            label: variables.variableMapping.source.name,
                            value: variables.variableMapping.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping.value !== null
                        ? [
                          {
                            label: variables.variableMapping.value.name,
                            value: variables.variableMapping.value.id,
                          },
                        ]
                        : [];
                  } else if (
                    variables.variableMapping?.source?.name === "Position"
                  ) {
                    const testplanId = this.state.testplanFormData.id;
                    const calculatedId = data.property?.id;
                    const propertyId = variables.property.id;
                    calculatedPropertyActions
                      .getPartitions(calculatedId, propertyId, testplanId)
                      .then(() => {
                        if (this._partitionName.length > 0) {
                          this._oldPartitionName = this._partitionName;
                        }
                        this._partitionListData.partitions.map(
                          (partitionName: any) => {
                            this._partitionName.push({
                              label: partitionName.name,
                              value:
                                partitionName.position + `(${randomNumber})`,
                            });
                          }
                        );
                        this.setState({}, () => {
                          this.forceUpdate();
                        });
                      })
                      .catch((error) => {
                        triggerNotifications
                          .errors(error.message, error.data)
                          .then();
                      });

                    disablePosition = false;
                    disableValue = false;
                    selectedSource =
                      variables.variableMapping?.source !== null
                        ? [
                          {
                            label: variables.variableMapping?.source.name,
                            value: variables.variableMapping?.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping?.value !== null
                        ? [
                          {
                            label: variables.variableMapping?.value.name,
                            value: variables.variableMapping?.value.id,
                          },
                        ]
                        : [];
                    selectedPosition =
                      variables.variableMapping.position !== null
                        ? variables.variableMapping.position +
                        `(${randomNumber})`
                        : "";
                    console.log(selectedPosition, "selectedPosition")
                    console.log(selectedValue, "selectedValue")
                    console.log(selectedSource, "selectedSource")
                  } else {
                    disablePosition = true;
                    disableValue = false;
                    selectedSource =
                      variables.variableMapping?.source !== null
                        ? [
                          {
                            label: variables.variableMapping?.source.name,
                            value: variables.variableMapping?.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping?.value !== null
                        ? [
                          {
                            label: variables.variableMapping?.value.name,
                            value: variables.variableMapping?.value.id,
                          },
                        ]
                        : [];
                  }
                } else {
                  disablePosition = true;
                  disableValue = true;
                  disableSource = true;
                  selectedSource = [];
                  selectedValue = [];
                  selectedPosition = "";
                }
                id = variables.id;
                variable = variables.variable;
                attribute = variables.attribute;
                property = variables.property;
                const varData = {
                  id,
                  variable,
                  attribute,
                  property,
                  selectedSource,
                  selectedValue,
                  selectedPosition,
                  disablePosition,
                  disableValue,
                  disableSource,
                };
                variableMapData.push(varData);
                selectedSource = [];
                selectedValue = [];
                selectedPosition = "";
              }
            );

            const calculatedPropertyDetailData = new CalculatedPropertyViewData(
              data.property?.id,
              data.property?.name,
              String(data.formulaMappings[0].formula),
              variableMapData
            );

            calculatedPropertyDetails.push(calculatedPropertyDetailData);
          }

          selectedCalculated.push(value);

          const property = this.state.testplanFormData.properties.find(
            (x) => x.propertyId === data.property?.id
          );
          const propertyIndex = this.state.testplanFormData.properties.findIndex(
            (x) => x.propertyId === data.property?.id
          );

          if (property !== undefined) {
            if (data.formulaMappings !== undefined) {
              data.formulaMappings[0].variableMapping.map((variables: any) => {
                const sourceId =
                  variables.variableMapping?.source === null
                    ? ""
                    : variables.variableMapping?.source.id;
                const position =
                  variables.variableMapping?.position === null
                    ? ""
                    : variables.variableMapping?.position;
                const valueId =
                  variables.variableMapping?.value === null
                    ? ""
                    : variables.variableMapping?.value.id;
                const sourceMappingData = {
                  sourceId,
                  position,
                  valueId,
                  propertyAttributeId: variables.attribute.id,
                  propertyId: variables.property.id,
                  variable: variables.variable,
                };
                this.state.testplanFormData.properties[
                  propertyIndex
                ].sourceMappings.push(sourceMappingData);
              });
            }
            properties = this.state.testplanFormData.allProperties.length
              ? this.state.testplanFormData.allProperties
              : this.state.testplanFormData.properties;
          }
          properties = this.state.testplanFormData.properties;
          isNext = true;
        });
      } else {
        properties = this.state.testplanFormData.allProperties.length
          ? this.state.testplanFormData.allProperties
          : this.state.testplanFormData.properties;
        isNext = false;
      }
      this._testplanproperties = properties.filter(
        (x) => x.isCalculated !== true
      );

      const selectedCalculatedProperties: any[] = [];
      if (Array.isArray(this.state.testplanFormData.selectedCalculatedProperty) &&
        this.state.testplanFormData.selectedCalculatedProperty.length) {
        this.state.testplanFormData.selectedCalculatedProperty.map((item: any) => {
          if (item.propertyId) {
            // property specification
            selectedCalculatedProperties.push({
              label: item.propertyName,
              value: item.propertyId,
            });
          } else {
            // calculated specification
            selectedCalculatedProperties.push({
              label: item.property.name,
              value: item.property.id,
            });
          }
        });
      }

      calculatedPropertyDetails.forEach((el) => {
        if (
          el.variables.find(
            (ele) => ele.attribute?.name === "Measured Property"
          )
        ) {
          this._indexValueCount = calculatedPropertyDetails.length;
        }
      });

      this.setState(
        {
          isNext,
          calculatedPropertyDetails,
          selectedCalculatedProperties,
          testplanFormData: {
            ...this.state.testplanFormData,
            selectedCalculatedProperties,
            calculatedProperties: selectedCalculatedProperties
          }
        },
        () => {
        }
      );
    }

    if (this.state.testplanFormData?.isEditMode) {
      this.state.testplanFormData?.instruments?.length === 0
        ? this.setState({ selectedToggle: [1] })
        : this.setState({ selectedToggle: [0] });
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_TESTPLAN,
          isSubmitDisabled: false,
        })
        .then();
      this.checkGlobalPostionsCountsStripLength();
    }

    if (this._mount) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_TESTPLAN,
          action: this.state.testplanFormData?.isEditMode
            ? CONSTANTS.EDIT
            : CONSTANTS.CREATE,
          icon: this.state.testplanFormData?.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.TESTPLAN_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
        })
        .then();
    }

    directionActions.getAll().then(() => {
      this._noDirection = this._directionList.find(
        (d) => d.name === CONSTANTS.ND || d.name === "--"
      );
    });

    propertyTypeActions.getAll().then(() => {
      propertyActions.getByType(this._keyedInPropertyType.id).then(() => {
        const items = this._keyedInPropertyList.map(
          (item: IKeyedInProperty) => {
            return {
              value: item.id,
              label: item.name,
            };
          }
        );
        this.setState(
          {
            keyedInPropertyList: items,
          },
          () => {
            this.setState({
              selectedKeyedInProperties: this.state.selectedKeyedInProperties,
              testplanFormData: {
                ...this.state.testplanFormData,
                selectedKeyedInProperties: this.state.selectedKeyedInProperties
              }
            });
          }
        );
      });
    });

    sourceActions
      .getAll(
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        const selectedSource: any = [];
        if (this.state.selectedSource[0]?.value)
          this._sourceList.forEach((item: any) => {
            if (item.value == this.state.selectedSource[0].value) {
              selectedSource.push({ value: item.value, label: item.label });
            }
          });
        if (selectedSource.length) {
          this.setState({
            sourceList: this.state.sourceList,
            selectedSource: selectedSource,
            testplanFormData: {
              ...this.state.testplanFormData,
              selectedSource: selectedSource,
            }
          });
        } else {
          this.setState({
            sourceList: this.state.sourceList,
          });
        }
      });

    sourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.sourceDataList.result.forEach((source: ISourceViewData) => {
          const data = {
            label: source.name,
            value: source.id,
            stripLength: source.stripLength,
          };
          this._sourceList.push(data);
        });
      }
    });

    instrumentSelectedIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._fetchedInstruments = state.instrumentDataList.result
        ? state.instrumentDataList.result
        : state.instrumentDataList;
      console.log(state.instrumentDataList);
    });

    propertySelectedIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._fetchedProperties = state.data.result
        ? state.data.result
        : state.data;
    });

    directionListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._directionList = state.directionDataList;
    });

    propertyTypeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._keyedInPropertyType = state.propertyTypeData.find(
        (d: IPropertyType) => d.name === CONSTANTS.KEYED_IN
      );
    });

    partitionsDetailsListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._partitionListData = state.data.result
        ? state.data.result
        : state.data;
    });

    propertySelectedCalculatedIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._fetchedCalculatedProperties = state.data.result
        ? state.data.result
        : state.data;
    });

    calculatedPropertyDetailsIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._calculatedPropertyDetails = [];
      this._calculatedPropertyDetails = state.data.result
        ? state.data.result
        : state.data;
    });

    calculatedPropertySourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._readingSourceDropdown = state.propertyDataList.result
        ? state.propertyDataList.result
        : state.propertyDataList;
    });

    calculatedPropertyValuesListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._readingValuesDropdown = state.propertyDataList.result
        ? state.propertyDataList.result
        : state.propertyDataList;
    });

    testplanFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._id = state.testplanId;
        this._isReload = false;
        this._messages = state.message;
      }
    });

    gradeFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._gradeId = state.gradeId;
        this._gradeMessages = state.message;
      }
    });

    instrumentListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        const data = state.instrumentDataList.result as IInstrumentViewData[];
        data.forEach((data) => {
          const directions: ITestPlanDirection[] = [];
          data.directionList.forEach((element) => {
            directions.push({
              id: element.id,
              name: element.name,
              count: 1,
            });
          });
          const index = this.state.instrumentPartitions.findIndex(
            (d) => d.id === data.id
          );
          if (index !== -1) {
            let instrumentPartitions = [...this.state.instrumentPartitions];
            let instrument = { ...instrumentPartitions[index] };
            instrument.directions = directions;
            instrumentPartitions[index] = instrument;
            this.setState({
              instrumentPartitions,
              testplanFormData: {
                ...this.state.testplanFormData,
                instruments: instrumentPartitions
              }
            });
          }

          this._instrumentList.push(
            new InstrumentData(data.id, data.name, directions, data.isAutoline)
          );
        });
      }
    });

    propertyListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        const data = state.propertyDataList.result as IPropertyViewData[];
        data.forEach((d) => {
          this._keyedInPropertyList.push(
            new KeyedInProperty(d.id, d.name, this._noDirection)
          );
        });
      }
    });

    instrumentActions
      .getAll(
        false,
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        const items = this._instrumentList.map((item: ITestPlanInstrument) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
        this.setState({
          instrumentList: items,
        });
      });

    this.getAllCalculatedPropertiesEdit();
    setTimeout(() => { this.onNextClick() }, 1000);
  }

  validate(): void {
    if (
      !this.state.nameError &&
      this.state.testplanFormData.name !== "" &&
      this.state.testplanFormData.name.trim() !== CONSTANTS.DefaultGuid &&
      this.state.testplanFormData.name.length > 1 &&
      this.state.instrumentPartitions.length === 0 &&
      this.state.keyedInPartitions.length === 0 && this.validateGrade()
    ) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_TESTPLAN,
          isSubmitDisabled: false,
        })
        .then();
    } else if (
      !this.state.nameError &&
      this.state.instrumentPartitions.length > 0 &&
      this.state.keyedInPartitions.length === 0 &&
      this.state.testplanFormData.name !== "" && this.validateGrade()
    ) {
      // check for only instrument
      this.state.instrumentPartitions.map((positionNumber) => {
        if (positionNumber.partitions.length === 0) {
          this.error(CONSTANTS.INVALID_POSITION);
          submitHeaderActions
            .update({
              moduleName: CONSTANTS.MODULE_TESTPLAN,
              isSubmitDisabled: true,
            })
            .then();
        } else {
          if (this.state.calculatedPropertyDetails.length !== 0 && !this.validateCalculatedPropertyDetails()) {
            submitHeaderActions
              .update({
                moduleName: CONSTANTS.MODULE_TESTPLAN,
                isSubmitDisabled: true,
              })
              .then();
          } else {
            submitHeaderActions
              .update({
                moduleName: CONSTANTS.MODULE_TESTPLAN,
                isSubmitDisabled: false,
              })
              .then();
          }
        }
      });
    } else if (
      !this.state.nameError &&
      this.state.keyedInPartitions.length > 0 &&
      this.state.instrumentPartitions.length === 0 &&
      this.state.testplanFormData.name !== "" && this.validateGrade()
    ) {
      // check for only keyedin
      this.state.keyedInPartitions.map((positionNumber) => {
        if (positionNumber.partitions.length === 0) {
          this.error(CONSTANTS.INVALID_POSITION);
          submitHeaderActions
            .update({
              moduleName: CONSTANTS.MODULE_TESTPLAN,
              isSubmitDisabled: true,
            })
            .then();
        } else {
          if (this.state.calculatedPropertyDetails.length !== 0 && !this.validateCalculatedPropertyDetails()) {
            submitHeaderActions
              .update({
                moduleName: CONSTANTS.MODULE_TESTPLAN,
                isSubmitDisabled: true,
              })
              .then();
          } else {
            submitHeaderActions
              .update({
                moduleName: CONSTANTS.MODULE_TESTPLAN,
                isSubmitDisabled: false,
              })
              .then();
          }
        }
      });
    } else if (
      !this.state.nameError &&
      this.state.instrumentPartitions.length > 0 &&
      this.state.keyedInPartitions.length > 0 &&
      this.state.testplanFormData.name !== "" && this.validateGrade()
    ) {
      // check for  instrument & keyedIN
      const overallStatus: any[] = [];
      this.state.instrumentPartitions.map((positionNumber) => {
        if (positionNumber?.partitions?.length === 0) {
          this.error(CONSTANTS.INVALID_POSITION);
          overallStatus.push(0);
        }
      });

      this.state.keyedInPartitions.map((positionNumber) => {
        if (positionNumber?.partitions?.length === 0) {
          this.error(CONSTANTS.INVALID_POSITION);
          overallStatus.push(0);
        }
      });

      if (overallStatus.some((x) => x === 0)) {
        submitHeaderActions
          .update({
            moduleName: CONSTANTS.MODULE_TESTPLAN,
            isSubmitDisabled: true,
          })
          .then();
      } else {
        if (this.state.calculatedPropertyDetails.length !== 0 &&
          !this.validateCalculatedPropertyDetails()) {
          submitHeaderActions
            .update({
              moduleName: CONSTANTS.MODULE_TESTPLAN,
              isSubmitDisabled: true,
            })
            .then();
        } else {
          submitHeaderActions
            .update({
              moduleName: CONSTANTS.MODULE_TESTPLAN,
              isSubmitDisabled: false,
            })
            .then();
        }
      }
    } else {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_TESTPLAN,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  public validateGrade = () => {
    let isGrade = true;
    if (this.state.testplanFormData.showGrade) {
      if (this.state.testplanFormData.showGrade &&
        this.state.testplanFormData.gradeName !== "" &&
        this.state.testplanFormData.gradeName?.trim() &&
        this.state.testplanFormData.gradeName?.length > 1
      ) {
        return isGrade = true
      } else {
        return isGrade = false
      }
    } else {
      return isGrade = true
    }
  }

  updatePropertiesOrder = () => {
    var propertyName = [];
    var rows = this.state.orderProperties;
    for (var i = 0; i < rows.length; i++) {
      var rowText = rows[i].firstChild.textContent;
      propertyName.push(rowText);
    }
    propertyName.shift();

    const properties = [...this.state.testplanFormData.properties];
    for (var j = 0; j < propertyName.length; j++) {
      const name: string = propertyName[j];
      for (var n = 0; n < properties.length; n++) {
        if (properties[n].propertyName === name) {
          properties[n].order = j + 1;
          break;
        }
      }
    }
    this.setState({
      testplanFormData: { ...this.state.testplanFormData, properties },
    });
  };

  validateCalculatedPropertyDetails = () => {
    let isEmpty = true;

    for (let i = 0; i < this.state.calculatedPropertyDetails.length; i++) {
      for (
        let j = 0;
        j < this.state.calculatedPropertyDetails[i]?.variables?.length;
        j++
      ) {
        if (
          this.state.calculatedPropertyDetails[i]?.variables[j]?.selectedSource &&
          this.state.calculatedPropertyDetails[i]?.variables[j]?.selectedSource[0]
            ?.label === "Individual"
        ) {
          if (
            !this.state.calculatedPropertyDetails[i]?.variables[j]?.selectedValue
              ?.length
          ) {
            isEmpty = false;
            break;
          }
        } else if (
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource &&
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource[0]
            ?.label === "Position"
        ) {
          if (
            !this.state.calculatedPropertyDetails[i]?.variables[j]
              .selectedPosition?.length
          ) {
            isEmpty = false;
            break;
          }
          if (
            !this.state.calculatedPropertyDetails[i]?.variables[j]?.selectedValue
              ?.length
          ) {
            isEmpty = false;
            break;
          }
        } else if (
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource &&
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource[0]
            ?.label === "Series"
        ) {
          if (
            !this.state.calculatedPropertyDetails[i]?.variables[j]?.selectedValue
              ?.length
          ) {
            isEmpty = false;
            break;
          }
        } else {
          isEmpty = false;
          break;
        }
        console.log(isEmpty);
      }
      console.log(isEmpty);
    }
    return isEmpty;
  };
  countValidate(
    value: string | number,
    direction: any,
    partition: any,
    index: number
  ): void {
    this.setState({ globalCountInput: undefined });
  }

  public validateDuplicatePosition = () => {
    const uniqueValues: Set<any> = new Set(
      this.state.keyedInPartitions[0]?.partitions?.map((element: any) =>
        element.name.replace(/ +(?= )/g, "").trim()
      )
    );
    if (uniqueValues.size < this.state.keyedInPartitions[0]?.partitions?.length) {
      triggerNotifications.error(CONSTANTS.TESTPLAN_DUPLICATE_POSITION).then();
      return true;
    }
    return false;
  };

  public onSaveClick = () => {
    if (this.state.keyedInPartitions.length) {
      // if there is keyedin exist
      if (this.validateDuplicatePosition()) {
        // then check for duplicates in keyedin
        return;
      }
    }

    const tempName = this.state.testplanFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    if(this.state.testplanFormData.showGrade){
      this.updatePropertiesOrder()
    }
    this.setState(
      (prevState) => ({
        isGlobalEditConfirm: false,
        editedInput: 0,
        formLoading: true,
        testplanFormData: {
          // object that we want to update
          ...prevState.testplanFormData, // keep all other key-value pairs
          name: tempName, // update the value of specific key
          isStripLengthFromSource: this.state.isSelectStripLength,
          sourceId:
            this.state.selectedSource.length > 0 &&
              Array.isArray(this.state.selectedSource[0]?.value)
              ? this.state.selectedSource[0]?.value[1]
              : this.state.selectedSource[0]?.value,
        },
      }),
      () => {
        testplanActions
          .put(
            this.state.testplanFormData,
            this.state.instrumentPartitions,
            this.state.keyedInPartitions
          )
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                if (this.state.testplanFormData.showGrade) {
                  gradeActions
                    .put(this.state.testplanFormData)
                    .then(() => {
                      this.setState(
                        {
                          formLoading: false,
                        },
                        () => {
                          triggerNotifications.success(this._messages);
                          setTimeout(() => {
                            history.push(CONSTANTS.TESTPLAN_INDEX_URL, {
                              isReloadFirst: this._isReload,
                              id: this._id,
                            });
                          }, CONSTANTS.NOTIFICATION_TIMEOUT);
                        }
                      );
                    })
                    .catch((error) => {
                      this.setState(
                        {
                          formLoading: false,
                        },
                        () => {
                          triggerNotifications.errors(error.message, error.data).then();
                        }
                      );
                    });
                } else {
                  triggerNotifications.success(this._messages);
                  setTimeout(() => {
                    history.push(CONSTANTS.TESTPLAN_INDEX_URL, {
                      isReloadFirst: this._isReload,
                      id: this._id,
                    });
                  }, CONSTANTS.NOTIFICATION_TIMEOUT);
                }
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  public onCreateClick = () => {
    if (this.state.keyedInPartitions.length) {
      // if there is keyedin exist
      if (this.validateDuplicatePosition()) {
        // then check for duplicates in keyedin
        return;
      }
    }
    const tempName = this.state.testplanFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    if(this.state.testplanFormData.showGrade){
      this.updatePropertiesOrder()
    }
    this.setState(
      (prevState) => ({
        formLoading: true,
        testplanFormData: {
          // object that we want to update
          ...prevState.testplanFormData, // keep all other key-value pairs
          name: tempName, // update the value of specific key
          isStripLengthFromSource: this.state.isSelectStripLength,
          sourceId:
            this.state.selectedSource.length > 0 &&
              this.state.isSelectStripLength
              ? this.state.selectedSource[0]?.value[1]
              : this.state.selectedSource[0]?.value
                ? this.state.selectedSource[0]?.value
                : CONSTANTS.DefaultGuid,
        },
      }),
      () => {
        testplanActions
          .post(
            this.state.testplanFormData,
            this.state.instrumentPartitions,
            this.state.keyedInPartitions
          )
          .then(() => {
            this.setState(
              {
                formLoading: false,
                testplanFormData: {
                  ...this.state.testplanFormData,
                  id: this._id
                }
              },
              () => {
                if (this.state.testplanFormData.showGrade) {
                  triggerNotifications
                    .success([
                      i18next.t("TestPlan created successfully with name ") +
                      this.state.testplanFormData.name + i18next.t(" Grade and Product creation in progress..."),
                    ])
                    .then();
                  gradeActions
                    .post(this.state.testplanFormData)
                    .then((id: any) => {
                      this.setState(
                        {
                          formLoading: false,
                          testplanFormData: {
                            ...this.state.testplanFormData,
                            gradeId: this._gradeId
                          }
                        },
                        () => {
                          triggerNotifications
                            .success([
                              i18next.t("Grade created successfully with name ") +
                              this.state.testplanFormData.gradeName + i18next.t(" Product creation in progress..."),
                            ])
                            .then()
                          var productFormData = new ProductFormData(
                            uuidv4(),
                            this.state.testplanFormData.isEditMode,
                            "",
                            this.state.testplanFormData.gradeName,
                            "",
                            this.state.testplanFormData.gradeCode,
                            new GradeBasicData(
                              this._gradeId,
                              this.state.testplanFormData.gradeName,
                              "",
                              this.state.testplanFormData.gradeCode,
                              true
                            ),
                            [],
                            [],
                            []
                          );

                          productFormData.properties =
                            this.state.testplanFormData.properties;

                          productActions
                            .post(productFormData)
                            .then(() => {
                              this.setState(
                                {
                                  formLoading: false,
                                },
                                () => {
                                  triggerNotifications
                                    .success([
                                      i18next.t("Product created successfully with name ") +
                                      productFormData.name,
                                    ])
                                    .then();
                                  setTimeout(() => {
                                    history.push(CONSTANTS.TESTPLAN_INDEX_URL, {
                                      isReloadFirst: this._isReload,
                                      id: this._id,
                                    });
                                  }, CONSTANTS.NOTIFICATION_TIMEOUT);
                                }
                              );
                            })
                            .catch((error) => {
                              this.setState(
                                {
                                  formLoading: false,
                                },
                                () => {
                                  triggerNotifications.errors(["Product Creation Failed - " + error.message], error.data).then();
                                  setTimeout(() => {
                                    history.push(CONSTANTS.TESTPLAN_INDEX_URL, {
                                      isReloadFirst: this._isReload,
                                      id: this._id,
                                    });
                                  }, CONSTANTS.NOTIFICATION_TIMEOUT);
                                }
                              );
                            });
                        }
                      );
                    })
                    .catch((error) => {
                      this.setState(
                        {
                          formLoading: false,
                        },
                        () => {
                          triggerNotifications.errors(["Grade Creation Failed - " + error.message], error.data).then();
                          setTimeout(() => {
                            history.push(CONSTANTS.TESTPLAN_INDEX_URL, {
                              isReloadFirst: this._isReload,
                              id: this._id,
                            });
                          }, CONSTANTS.NOTIFICATION_TIMEOUT);
                        }
                      );
                    });
                } else {
                  triggerNotifications.success(this._messages);
                  setTimeout(() => {
                    history.push(CONSTANTS.TESTPLAN_INDEX_URL, {
                      isReloadFirst: this._isReload,
                      id: this._id,
                    });
                  }, CONSTANTS.NOTIFICATION_TIMEOUT);
                }
              }
            );
          })
          .catch((error) => {
            console.log("error", error);
            this.setState(
              {
                formLoading: false,
              },
              () => triggerNotifications.errors(error.message, error.data)
            );
          });
      }
    );
  };

  public onToggle(togglePosition: any[]) {
    this.setState({
      selectedToggle: togglePosition,
      activeTab: 0,
    });
  }

  private onCloseAll = (e: any) => {
    const dt: any = this.optionRef.current;
    const dy = dt?.contains(e.target);
    if (this.optionRef.current && !dy) {
      const calculatedPropertyDetails = [
        ...this.state.calculatedPropertyDetails,
      ];
      calculatedPropertyDetails.map((x) => {
        x.variables.map((y) => (y.isSelected = false));
      });
      this.setState({
        calculatedPropertyDetails,
        testplanFormData: {
          ...this.state.testplanFormData,
        },
      });
    }
  };

  private onToggleClick = (
    e: any,
    index: number,
    i: number,
    calculatedId: string
  ) => {
    e.preventDefault();
    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    variables.map((x) => (x.isSelected = false));
    if (variables[i].isSelected === true) {
      variables[i].isSelected = false;
    } else {
      variables[i].isSelected = true;
    }
    this.setState(
      {
        calculatedPropertyDetails,
        testplanFormData: {
          ...this.state.testplanFormData,
        },
      },
      () => this.onEditPartitionChange(e, index, i, calculatedId)
    );
  };

  private onEditPartitionChange(
    value: any,
    index: number,
    i: number,
    calculatedId: string
  ) {
    const allproperties = this.state.testplanFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    const propertyId = allproperties.sourceMappings[i].propertyId;
    const testplanId = this.state.testplanFormData.id;
    calculatedPropertyActions
      .getPartitions(calculatedId, propertyId, testplanId)
      .then(() => {
        if (this._partitionName.length > 0) {
          this._partitionName.map((x) => (x.disabled = true));
        }
        this._partitionListData.partitions.map(
          (partitionName: any, ids: any) => {
            this._partitionName.push({
              label: partitionName.name,
              value: partitionName.position + `(${Math.random()})`,
              disabled: false,
            });
          }
        );
        this.setState({}, () => {
          this.forceUpdate();
        });
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  }

  private onSourceChangeHandler(
    value: any,
    index: number,
    i: number,
    calculatedId: string
  ) {
    this.setState({
      isLoading: true,
    });

    this._indexSourceCount = i;
    const properties = this.state.testplanFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    properties.sourceMappings[i].sourceId = value[0]?.value;
    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    calculatedPropertyDetail.onSourceDropdown(value, i);
    variables[i].selectedSource = value;
    variables[i].selectedValue = [];

    if (value[0].label === "Position") {
      const propertyId = properties.sourceMappings[i].propertyId;
      const testplanId = this.state.testplanFormData.id;
      calculatedPropertyActions
        .getPartitions(calculatedId, propertyId, testplanId)
        .then(() => {
          if (this._partitionName.length > 0) {
            this._partitionName.map((x) => (x.disabled = true));
          }
          this._partitionListData.partitions.map(
            (partitionName: any, ids: any) => {
              this._partitionName.push({
                label: partitionName.name,
                value: partitionName.position + `(${Math.random()})`,
                disabled: false,
              });
            }
          );
          this.setState(
            {
              isLoading: false,
            },
            () => this.forceUpdate()
          );
        })
        .catch((error) => {
          this.setState(
            {
              isLoading: false,
            },
            () => {
              triggerNotifications.errors(error.message, error.data).then();
            }
          );
        });
    }

    if (value[0].label !== "Position") {
      variables[i].selectedPosition = "";
    }

    this.setState(
      {
        calculatedPropertyDetails,
        testplanFormData: {
          ...this.state.testplanFormData,
        },
      },
      () => {
        this.validate();
        if (value[0].label === "Individual") {
          const valuesDropDownList = this._readingValuesList.find(
            (x) => x.label === "Value"
          );
          this.onValuesChangeHandler(
            [valuesDropDownList],
            index,
            i,
            calculatedId
          );
          const readingValuesList: any[] = [];
          this._readingValuesList.map((x: any) => {
            if (x.label === "Value") {
              readingValuesList.push({
                label: x.label,
                value: x.value,
                isNew: false,
              });
            } else {
              readingValuesList.push({
                label: x.label,
                value: x.value,
                isNew: false,
              });
            }
          });
          this.setState({
            readingValuesList,
          });
        } else {
          const readingValuesList = this._readingValuesList.filter(
            (x) => x.label !== "Value"
          );
          this.setState({
            valueList: readingValuesList,
          });
        }
      }
    );
  }

  thresholdvalue = () => {
    this.setState({
      testplanFormData: {
        ...this.state.testplanFormData,
        showformula: false
      },
      showthreshold: true
    })
  };

  formuladefinition = () => {
    this.setState({
      testplanFormData: {
        ...this.state.testplanFormData,
        showformula: !this.state.testplanFormData.showformula
      },
    })
  };

  private onChangeValue = (e: any, rowIndex: number, colIndex: number) => {
    const name = e === "sigmaPercent" ? e : e.target.name;

    const properties = [...this.state.testplanFormData.properties];
    const item: any = properties[rowIndex];

    if (name.indexOf(".") !== -1) {
      const data = e.target.name.split(".");
      let result: any = item;
      for (let index = 0; index < data.length - 1; index++) {
        result = result[data[index]];
      }
      const targetVal = e.target.value;
      result[data[data.length - 1]] = targetVal;
    } else if (name === "sigmaPercent") {
      item["sigmaPercent"] = !item["sigmaPercent"];
    } else {
      const targetVal = e.target.value;
      item[e.target.name] = targetVal;
    }

    if (item["sigma"] && item["target"]) {
      if (item["sigmaPercent"]) {
        const sigma = parseFloat(item["sigma"]);
        const temp = (parseFloat(item["target"]) * sigma) / 100;
        item["alarmLow1"] = (parseFloat(item["target"]) - temp).toString();
        item["alarmHigh1"] = (parseFloat(item["target"]) + temp).toString();
      } else {
        if (
          item["sigma"].length &&
          item["target"].length &&
          (e === "sigmaPercent" ||
            e.target.name === "sigma" ||
            e.target.name === "target")
        ) {
          item["alarmLow1"] = (
            parseFloat(item["target"]) - parseFloat(item["sigma"])
          ).toString();
          item["alarmHigh1"] = (
            parseFloat(item["target"]) + parseFloat(item["sigma"])
          ).toString();
        }
      }
    }
    properties[rowIndex] = item;
    this.setState(
      {
        testplanFormData: { ...this.state.testplanFormData, properties },
      },
      () => {
      }
    );
  };

  private onBlurValue = (e: any, rowIndex: number, colIndex: number) => {
    const properties = [...this.state.testplanFormData.properties];

    // reverse case for min and max value
    if (
      properties[rowIndex].minValue &&
      properties[rowIndex].minValue &&
      Number(properties[rowIndex].minValue) !== 0 &&
      Number(properties[rowIndex].maxValue) !== 0 &&
      Number(properties[rowIndex].maxValue) <
      Number(properties[rowIndex].minValue)
    ) {
      triggerNotifications.error(CONSTANTS.MIN_MAX_ERROR);
    }

    // rejectHigh
    if (
      properties[rowIndex].rejectLow &&
      properties[rowIndex].minValue &&
      Number(properties[rowIndex].rejectLow) !== 0 &&
      Number(properties[rowIndex].rejectLow) <=
      Number(properties[rowIndex].minValue)
    ) {
      triggerNotifications.error(CONSTANTS.REJECT_LOW_MIN_ERROR);
    }
    if (
      properties[rowIndex].rejectHigh &&
      properties[rowIndex].maxValue &&
      Number(properties[rowIndex].rejectHigh) !== 0 &&
      Number(properties[rowIndex].rejectHigh) >=
      Number(properties[rowIndex].maxValue)
    ) {
      triggerNotifications.error(CONSTANTS.REJECT_HIGH_MAX_ERROR);
    }

    // alarm low 2
    if (
      properties[rowIndex].rejectLow &&
      properties[rowIndex].alarmLow2 &&
      Number(properties[rowIndex].alarmLow2) !== 0 &&
      Number(properties[rowIndex].alarmLow2) <=
      Number(properties[rowIndex].rejectLow)
    ) {
      triggerNotifications.error(CONSTANTS.LOW_REJECT_LOW_ERROR);
    }

    if (
      properties[rowIndex].alarmHigh2 &&
      properties[rowIndex].rejectHigh &&
      Number(properties[rowIndex].alarmHigh2) !== 0 &&
      Number(properties[rowIndex].alarmHigh2) >=
      Number(properties[rowIndex].rejectHigh)
    ) {
      triggerNotifications.error(CONSTANTS.HIGH_REJECT_HIGH_ERROR);
    }

    // low1
    if (
      properties[rowIndex].alarmLow1 &&
      properties[rowIndex].alarmLow2 &&
      Number(properties[rowIndex].alarmLow1) !== 0 &&
      Number(properties[rowIndex].alarmLow2) !== 0 &&
      Number(properties[rowIndex].alarmLow2) >=
      Number(properties[rowIndex].alarmLow1)
    ) {
      triggerNotifications.error(i18next.t(CONSTANTS.LOW1_LOW2_ERROR));
    }

    if (
      properties[rowIndex].alarmHigh2 &&
      properties[rowIndex].alarmHigh1 &&
      Number(properties[rowIndex].alarmHigh2) !== 0 &&
      Number(properties[rowIndex].alarmHigh1) !== 0 &&
      Number(properties[rowIndex].alarmHigh2) <=
      Number(properties[rowIndex].alarmHigh1)
    ) {
      triggerNotifications.error(i18next.t(CONSTANTS.HIGH1_HIGH2_ERROR));
    }
  };

  private setPropertiesOrderNo = (rowData: any[]) => {
    this.setState({
      orderProperties: rowData,
    });
  };

  private onAddGradeClick = () => {
    this.setState({
      testplanFormData: {
        ...this.state.testplanFormData,
        showGrade: !this.state.testplanFormData.showGrade,
        showformula: false
      },
      showthreshold: true
    }, () => {
      this.validate();
      if (!this.state.testplanFormData.showGrade) {
        calculatedPropertyActions
          .getAllSource()
          .then(() => {
            this._readingSourceList = [];
            this._readingSourceDropdown.forEach((element: IReading) => {
              this._readingSourceList.push({
                label: element.name,
                value: element.id,
              });
            });
            this.setState(
              {
                readingSourceList: this._readingSourceList,
              },
              () => this.forceUpdate()
            );
          })
          .catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
          });

        calculatedPropertyActions
          .getAllValues()
          .then(() => {
            this._readingValuesList = [];
            this._readingValuesDropdown.forEach((element: IReading) => {
              this._readingValuesList.push({
                label: element.name,
                value: element.id,
                isNew: false,
              });
            });
            const valueList = this._readingValuesList.filter(
              (x) => x.label !== "Value"
            );

            this.setState(
              {
                readingValuesList: this._readingValuesList,
                valueList: valueList,
              },
              () => this.forceUpdate()
            );
          })
          .catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
          });
      }
    })
  }

  associationAction = () => {
    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_PROPERTY,
        action: CONSTANTS.ASSOCIATE,
        icon: ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.GRADE_CREATE_URL,
        isGoBackWithData: true,
        goBackData: this.state.testplanFormData,
      })
      .then();
    history.push(CONSTANTS.GRADE_ASSOCIATE_PROPERTY_URL, {
      testPlanFormData: this.state.testplanFormData,
      allCalculatedDropdownList: this.state.allCalculatedDropdownList,
      instrumentDropdownList: this.state.instrumentList,
      selectedInstrument: this.state.selectedInstruments,
      selectedKeyedIn: this.state.selectedKeyedInProperties,
    });
  };

  private onNextClick = () => {
    if (this.state.testplanFormData.isEditMode) {
      const calculatedPropertyDetails = [
        ...this.state.calculatedPropertyDetails,
      ];
      const calculatedPropertyDetail = calculatedPropertyDetails;
      calculatedPropertyDetail.map((item, index) => {
        item.variables.map((x, ids) => {
          const dt = this._partitionName.find(
            (y) => y.value === x.selectedPosition
          );
          x.selectedPosition = dt !== undefined ? dt.label : "";
        });
      });

      this.setState({
        calculatedPropertyDetails,
        testplanFormData: {
          ...this.state.testplanFormData,
        },
      });
    } else {
      const calculatedPropertyDetails = [
        ...this.state.calculatedPropertyDetails,
      ];
      const calculatedPropertyDetail = calculatedPropertyDetails;
      calculatedPropertyDetail.map((item, index) => {
        item.variables.map((x, ids) => {
          x.disablePosition = true;
        });
      });

      this.setState({
        calculatedPropertyDetails,
        testplanFormData: {
          ...this.state.testplanFormData,
        },
      });
    }

    this.setState(
      {
        testplanFormData: {
          ...this.state.testplanFormData,
          showformula: this.state.calculatedPropertyDetails?.length > 0 ? !this.state.testplanFormData.showformula : false,
        },
        isStep: true,
      },
      () => {
        calculatedPropertyActions
          .getAllSource()
          .then(() => {
            this._readingSourceList = [];
            this._readingSourceDropdown.forEach((element: IReading) => {
              this._readingSourceList.push({
                label: element.name,
                value: element.id,
              });
            });
            this.setState(
              {
                readingSourceList: this._readingSourceList,
              },
              () => this.forceUpdate()
            );
          })
          .catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
          });

        calculatedPropertyActions
          .getAllValues()
          .then(() => {
            this._readingValuesList = [];
            this._readingValuesDropdown.forEach((element: IReading) => {
              this._readingValuesList.push({
                label: element.name,
                value: element.id,
                isNew: false,
              });
            });
            const valueList = this._readingValuesList.filter(
              (x) => x.label !== "Value"
            );

            this.setState(
              {
                readingValuesList: this._readingValuesList,
                valueList: valueList,
              },
              () => this.forceUpdate()
            );
          })
          .catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
          });
      }
    );
  };

  setGradeCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() === "" || (!rgFile.test(value) && value.trim())) {
      this.setState(
        {
          gradeCodeError: false,
          testplanFormData: {
            ...this.state.testplanFormData,
            gradeCode: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          gradeCodeError: true,
          testplanFormData: {
            ...this.state.testplanFormData,
            gradeCode: val,
          },
        },
        this.validate
      );
    }
  };

  setGradeName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      value.trim() &&
      !rgFile.test(value)
    ) {
      this.setState(
        {
          gradeNameError: false,
          testplanFormData: {
            ...this.state.testplanFormData,
            gradeName: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          gradeNameError: true,
          testplanFormData: {
            ...this.state.testplanFormData,
            gradeName: val,
          },
        },
        this.validate
      );
    }
  };

  private onPartitionChangeHandler(
    value: any,
    index: number,
    i: number,
    calculatedId: string,
    selectedElement: any
  ) {
    this._indexPartitionCount = i;
    const properties = this.state.testplanFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    properties.sourceMappings[i].position = JSON.stringify(selectedElement.value).replace(
      / *\([^)]*\) */g,
      ""
    );
    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    variables[i].selectedPosition = selectedElement.label;
    variables[i].isSelected = false;
    this.setState(
      {
        calculatedPropertyDetails,
        testplanFormData: {
          ...this.state.testplanFormData,
        },
      },
      () => {
        this.validate();
      }
    );
  }

  private onValuesChangeHandler(
    value: any,
    index: number,
    i: number,
    calculatedId: string
  ) {
    this._indexValueCount = i;
    const properties = this.state.testplanFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    properties.sourceMappings[i].valueId = value[0]?.value;

    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    variables[i].selectedValue = value;
    this.setState(
      {
        calculatedPropertyDetails,
        testplanFormData: {
          ...this.state.testplanFormData,
        },
      },
      this.validate
    );
  }

  private error(message: string) {
    triggerNotifications.error(message).then();
  }

  private inputFixedPositionHandler = (value: string, index: number) => {
    if (this.state.selectedToggle[0] === 0) {
      let instrumentPartitions = [...this.state.instrumentPartitions];
      let instrument: ITestPlanInstrument = { ...instrumentPartitions[index] };
      const lengthVal = value.split(".").join("");
      if (
        TestplanInstrumentOperations.isValid(
          instrument.stripLength,
          Number(lengthVal),
          instrument.partitionsCount,
          instrument.isFixedPosition
        )
      ) {
        TestplanInstrumentOperations.setPositionWidth(
          instrument,
          Number(lengthVal)
        );
        instrumentPartitions[index] = instrument;
        this.setState({
          instrumentPartitions,
          testplanFormData: {
            ...this.state.testplanFormData,
            instruments: instrumentPartitions
          }
        });
      } else {
        this.error(CONSTANTS.INVALID_FIXED_WIDTH);
      }
    }
  };

  private inputStripLengthHandler = (value: string, index: number) => {
    if (this.state.selectedToggle[0] === 0) {
      let instrumentPartitions = [...this.state.instrumentPartitions];
      let instrument = { ...instrumentPartitions[index] };
      const lengthVal = value.split(".").join("");
      TestplanInstrumentOperations.setInstrumentStripLength(
        instrument,
        Number(lengthVal)
      );
      instrumentPartitions[index] = instrument;
      this.setState({
        instrumentPartitions,
        testplanFormData: {
          ...this.state.testplanFormData,
          instruments: instrumentPartitions
        }
      });
    }
  };

  private isFixedPositionHandler = (value: any, index: number) => {
    const selectedToggle = this.state.selectedToggle[0];
    if (selectedToggle === 0) {
      let instrumentPartitions = [...this.state.instrumentPartitions];
      let instrument = { ...instrumentPartitions[index] };
      TestplanInstrumentOperations.setIsFixedPosition(instrument, value);
      instrumentPartitions[index] = instrument;
      this.setState({
        instrumentPartitions,
        testplanFormData: {
          ...this.state.testplanFormData,
          instruments: instrumentPartitions
        }
      });
    }
  };

  private inputNumberOfPositionHandler = (value: string, index: number) => {
    if(this.state.testplanFormData.isEditMode){
      const calculatedPropertyDetails = this.state.calculatedPropertyDetails
      calculatedPropertyDetails.map((item: any) => {
        item.variables.map((x:any) => {
          x.selectedPosition = ""
        })
      })
      this.setState({
        calculatedPropertyDetails
      })
    }
    if (value === undefined) value = "1";
    if (Number(value) < 0) {
      this.error(CONSTANTS.INVALID_POSITION);
      return;
    }
    if (this.state.selectedToggle[0] === 0) {
      let instrumentPartitions = [...this.state.instrumentPartitions];
      let instrument = { ...instrumentPartitions[index] };
      const lengthVal = value.toString().split(".").join("");
      if (
        TestplanInstrumentOperations.isValid(
          instrument.stripLength,
          instrument.fixedPositionWidth,
          Number(lengthVal),
          instrument.isFixedPosition
        )
      ) {
        TestplanInstrumentOperations.setPartitions(
          instrument,
          Number(lengthVal)
        );
        instrumentPartitions[index] = instrument;
        this.setState(
          {
            instrumentPartitions,
            testplanFormData: {
              ...this.state.testplanFormData,
              instruments: instrumentPartitions
            }
          },
          () => {
            this.validate();
          }
        );
      } else {
        this.error(CONSTANTS.INVALID_POSITION);
      }
    } else if (this.state.selectedToggle[0] === 1) {
      const keyedInPartitions = this.state.keyedInPartitions;
      const keyedIn = keyedInPartitions[index];
      let preserveKeyedInPartition = JSON.parse(
        JSON.stringify(keyedIn.partitions)
      );
      keyedIn.setPartitions(this._noDirection, Number(value));

      if (value > preserveKeyedInPartition.length) {
        let result = _(keyedIn.partitions)
          .differenceBy(preserveKeyedInPartition, "index")
          .value();
        keyedIn.partitions = [...preserveKeyedInPartition, ...result];
      } else {
        keyedIn.partitions = preserveKeyedInPartition.splice(
          0,
          preserveKeyedInPartition.length - 1
        );
      }
      keyedInPartitions[index] = keyedIn;
      this.setState(
        {
          keyedInPartitions,
          testplanFormData: {
            ...this.state.testplanFormData,
            keyedInPartitions
          }
        },
        () => {
          this.validate();
        }
      );
    }
    //check global position value with individual position
    this.setState({ isAllPositionsEqual: true });
    if (Number(value) !== this._globalPosition) {
      this.setState({
        isAllPositionsEqual: false,
        globalPositionInput: undefined,
      });
      return;
    }
  };

  updateGlobalPostionsAndCounts = () => {
    const maxMeasuredPosition = this.state.testplanFormData.instruments.reduce(
      (acc, item) =>
        (acc = acc > item.partitionsCount ? acc : item.partitionsCount),
      0
    );
    const maxKeyedInPosition = this.state.testplanFormData.keyedIns.reduce(
      (acc, item) =>
        (acc = acc > item.partitionsCount ? acc : item.partitionsCount),
      0
    );

    // update keyedin count at global level
    let maxMeasuredCount = 0;
    this.state.testplanFormData.instruments.forEach((value: any) => {
      if (!value.isAutoline) {
        const max = value.partitions.reduce(
          (acc: any, item: any) =>
          (acc =
            acc > item.directions[0].count ? acc : item.directions[0].count),
          0
        );
        if (max > maxMeasuredCount) maxMeasuredCount = max;
      }
    });
    // update measured count at global level
    let maxKeyedInCount = 0;
    this.state.testplanFormData.keyedIns.forEach((value: any) => {
      const max = value.partitions.reduce(
        (acc: any, item: any) =>
        (acc =
          acc > item.directions[0].count ? acc : item.directions[0].count),
        0
      );
      if (max > maxKeyedInCount) maxKeyedInCount = max;
    });
    let maxPosition = 1,
      maxCount = 1;
    if (maxMeasuredPosition >= maxKeyedInPosition) {
      maxPosition = maxMeasuredPosition;
    } else {
      maxPosition = maxKeyedInPosition;
    }

    if (maxMeasuredCount >= maxKeyedInCount) {
      maxCount = maxMeasuredCount;
    } else {
      maxCount = maxKeyedInCount;
    }
    this.setState({
      globalPositionInput: maxPosition,
      globalCountInput: maxCount,
    });
  };

  private handleGlobalEdit = () => {
    this.setState(
      {
        isGlobalEditConfirm: true,
        editGlobalValuesModalVisible: false,
        isAllPositionsEqual: true,
        isAllCountsEqual: true,
        isAllStripLengthEqual: true,
      },
      () => {
        if (this.state.globalEditMode === "Positions") {
          this.inputNumberOfGlobalPosition(this.state.editedInput);
        } else if (this.state.globalEditMode === "Counts") {
          this.inputNumberOfGlobalCount(this.state.editedInput);
        } else {
          this.inputGlobalStripLength(String(this.state.editedInput));
        }
      }
    );
  };

  checkGlobalPostionsCountsStripLength = () => {
    const positions: any[] = [];
    const counts: any[] = [];
    const stripLength: any[] = [];

    this.state.testplanFormData.instruments.map((item) => {
      if (!item.isAutoline) {
        positions.push(item.partitionsCount);
      }
    });
    this.state.testplanFormData.keyedIns.map((item: any) => {
      positions.push(item.partitionsCount);
    });

    this.state.testplanFormData.instruments.forEach((item: any) => {
      if (!item.isAutoline) {
        item.partitions.map((d: any) => {
          d.directions.map((v: any) => {
            counts.push(v.count);
          });
        });
      }
    });

    this.state.testplanFormData.keyedIns.forEach((item: any) => {
      item.partitions.map((d: any) => {
        d.directions.map((v: any) => {
          counts.push(v.count);
        });
      });
    });

    this.state.testplanFormData.instruments.map((item: any) => {
      if (!item.isAutoline) {
        stripLength.push(item.stripLength);
      }
    });

    let isAllEqualPosition = true;
    let isAllEqualCounts = true;
    let isAllEqualStripLength = true;
    positions.forEach((value: number, index: number) => {
      if (value !== positions[0]) isAllEqualPosition = false;
    });

    counts.forEach((value: number, index: number) => {
      if (value !== counts[0]) isAllEqualCounts = false;
    });

    stripLength.forEach((value: number, index: number) => {
      if (value !== stripLength[0]) isAllEqualStripLength = false;
    });

    this.setState({
      isAllPositionsEqual: isAllEqualPosition,
      isAllCountsEqual: isAllEqualCounts,
      isAllStripLengthEqual: isAllEqualStripLength,
      globalPositionInput: isAllEqualPosition ? positions[0] : null,
      globalCountInput: isAllEqualCounts ? counts[0] : null,
      globalStripLength: isAllEqualStripLength ? stripLength[0] : null,
    });
    this._globalPosition = isAllEqualPosition ? positions[0] : 0;
    this._globalCOunt = isAllEqualCounts ? counts[0] : 0;
  };

  private inputNumberOfGlobalPosition = (value: Number | string) => {
    if (value === undefined) value = "1";
    if (Number(value) < 0) {
      this.error(CONSTANTS.INVALID_POSITION);
      return;
    }

    if (
      this.state.testplanFormData.isEditMode &&
      !this.state.isGlobalEditConfirm
    ) {
      this.setState({
        editGlobalValuesModalVisible: true,
        globalEditMode: "Positions",
        editedInput: Number(value),
      });
      return;
    }

    // update keyedin positions at global level
    let keyedInPartitions = [...this.state.keyedInPartitions];
    let keyedInPropertyList = [...this._keyedInPropertyList];
    keyedInPartitions.forEach((item: any, index: number) => {
      const keyedIn = keyedInPartitions[index];
      let preserveKeyedInPartition = JSON.parse(
        JSON.stringify(keyedIn.partitions)
      );
      keyedIn.setPartitions(this._noDirection, Number(value));

      if (value > preserveKeyedInPartition.length) {
        let result = _(keyedIn.partitions)
          .differenceBy(preserveKeyedInPartition, "index")
          .value();
        keyedIn.partitions = [...preserveKeyedInPartition, ...result];
      } else {
        keyedIn.partitions = preserveKeyedInPartition.splice(
          0,
          preserveKeyedInPartition.length - 1
        );
      }
      keyedInPartitions[index] = keyedIn;
      this.setState(
        {
          keyedInPartitions,
          testplanFormData: {
            ...this.state.testplanFormData,
            keyedInPartitions
          }
        },
        () => {
          this.validate();
        }
      );
    });

    // update keyedinlist positions at global level
    keyedInPropertyList.forEach((item: any, i: number) => {
      const keyedIns = keyedInPropertyList[i];
      keyedIns.setPartitions(this._noDirection, Number(value));
      keyedInPropertyList[i] = keyedIns;
    });

    // update measured positions at global level
    let instrumentPartitions = [...this.state.instrumentPartitions];
    instrumentPartitions.forEach((data: any, index: number) => {
      if (!this.state.instrumentPartitions[index].isAutoline) {
        data.partitionsCount = value;
      }
      let instrument = { ...instrumentPartitions[index] };
      const lengthVal = value.toString().split(".").join("");
      if (
        TestplanInstrumentOperations.isValid(
          instrument.stripLength,
          instrument.fixedPositionWidth,
          Number(lengthVal),
          instrument.isFixedPosition
        )
      ) {
        if (!instrument.isAutoline) {
          TestplanInstrumentOperations.setPartitions(
            instrument,
            Number(lengthVal)
          );
        }
        instrumentPartitions[index] = instrument;
        this.setState(
          {
            instrumentPartitions,
            testplanFormData: {
              ...this.state.testplanFormData,
              instruments: instrumentPartitions
            }
          },
          () => {
            this.validate();
          }
        );
      } else {
        this.error(CONSTANTS.INVALID_POSITION);
      }
    });

    // update measured instrumentlist positions at global level
    let instrumentList = [...instrumentPartitions];
    instrumentList.forEach((data: any, index: number) => {
      if (!this.state.instrumentList[index].isAutoline) {
        data.partitionsCount = value;
      }
      let instrument = { ...instrumentList[index] };
      const lengthVal = value.toString().split(".").join("");
      if (
        TestplanInstrumentOperations.isValid(
          instrument.stripLength,
          instrument.fixedPositionWidth,
          Number(lengthVal),
          instrument.isFixedPosition
        )
      ) {
        if (!instrument.isAutoline) {
          TestplanInstrumentOperations.setPartitions(
            instrument,
            Number(lengthVal)
          );
        }
        instrumentList[index] = instrument;
      } else {
        this.error(CONSTANTS.INVALID_POSITION);
      }
    });

    this.setState({
      globalPositionInput: Number(value),
      editGlobalValuesModalVisible: false,
      globalEditMode: "",
    });
    this._globalPosition = Number(value);
    this.setState({ isAllPositionsEqual: true });
    if (Number(value) !== this._globalPosition) {
      this.setState({ isAllPositionsEqual: false });
      return;
    }

    if(this.state.testplanFormData.isEditMode){
      const calculatedPropertyDetails = this.state.calculatedPropertyDetails
      calculatedPropertyDetails.map((item: any) => {
        item.variables.map((x:any) => {
          x.selectedPosition = ""
        })
      })
      this.setState({
        calculatedPropertyDetails
      })
    }
  };

  private inputNumberOfGlobalCount = (value: Number | string) => {
    if (value === undefined) value = "1";
    if (Number(value) < 0) {
      this.error(CONSTANTS.INVALID_POSITION);
      return;
    }
    if (
      this.state.testplanFormData.isEditMode &&
      !this.state.isGlobalEditConfirm
    ) {
      this.setState({
        editGlobalValuesModalVisible: true,
        globalEditMode: "Counts",
        editedInput: Number(value),
      });
      return;
    }
    // update keyedin count at global level
    let keyedInPartitions = [...this.state.keyedInPartitions];
    keyedInPartitions.forEach((item: any) => {
      item.partitions.forEach((data: any) => {
        data.directions.forEach((dir: any) => {
          dir.count = value;
        });
        this.onSaveKeyedInPartition(item, data, false, "global");
      });
    });
    // update keyedinlist counts at global level
    let keyedInPropertyList = [...this._keyedInPropertyList];
    keyedInPropertyList.forEach((item: any) => {
      item.partitions.forEach((data: any) => {
        data.directions.forEach((dir: any) => {
          dir.count = value;
        });
      });
    });

    // update measured count at global level
    let instrumentPartitions = [...this.state.instrumentPartitions];
    instrumentPartitions.forEach((item: any) => {
      if (!item.isAutoline) {
        item.partitions.forEach((data: any) => {
          data.directions.forEach((dir: any) => {
            dir.count = value;
          });
          this.saveMeasuredPartition(item, data, false, "global");
        });
      }
    });

    // update measured count at global level
    let instrumentList = [...this._instrumentList];
    instrumentList.forEach((item: any) => {
      if (!item.isAutoline) {
        item.partitions.forEach((data: any) => {
          data.directions.forEach((dir: any) => {
            dir.count = value;
          });
        });
      }
    });

    this.setState({
      globalCountInput: Number(value),
      editGlobalValuesModalVisible: false,
      globalEditMode: "",
    });
    this._globalCOunt = Number(value);
    this.setState({ isAllCountsEqual: true });
    if (Number(value) !== this._globalCOunt) {
      this.setState({ isAllCountsEqual: false });
      return;
    }
  };

  inputGlobalStripLength = (value: string) => {
    if (
      this.state.testplanFormData.isEditMode &&
      !this.state.isGlobalEditConfirm
    ) {
      this.setState({
        editGlobalValuesModalVisible: true,
        globalEditMode: "StripLength",
        editedInput: Number(value),
      });
      return;
    }
    // update strip length at global level
    let instrumentPartitions = [...this.state.instrumentPartitions];
    this.state.instrumentPartitions.forEach((data: any, index: number) => {
      let instrument = { ...instrumentPartitions[index] };
      const lengthVal = value.split(".").join("");
      TestplanInstrumentOperations.setInstrumentStripLength(
        instrument,
        Number(lengthVal)
      );
      instrumentPartitions[index] = instrument;
    });
    this.setState({
      instrumentPartitions,
      globalStripLength: Number(value),
      editGlobalValuesModalVisible: false,
      globalEditMode: "",
      testplanFormData: {
        ...this.state.testplanFormData,
        instruments: instrumentPartitions
      }
    });
  };

  private setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      value.trim() &&
      !rgFile.test(value)
    ) {
      this.setState(
        {
          nameError: false,
          testplanFormData: {
            ...this.state.testplanFormData,
            name: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          nameError: true,
          testplanFormData: {
            ...this.state.testplanFormData,
            name: val,
          },
        },
        this.validate
      );
    }
  };

  private setDescription = (value: string) => {
    this.setState({
      testplanFormData: {
        ...this.state.testplanFormData,
        description: value,
      },
    });
  };

  private setPDC = (value: string) => {
    this.setState({
      testplanFormData: {
        ...this.state.testplanFormData,
        isPDC: value === measurementOrder.Position,
      },
    });
  };

  private instrumentChangeHandler = (values: any) => {
    let instrumentToBeRemoved = "";
    if (values.length === 0) {
      instrumentToBeRemoved = this.state.selectedInstruments[0].label;
    } else {
      if (
        this.state.selectedInstruments.some(
          (d: any) => !values.map((x: any) => x.value).includes(d.value)
        )
      ) {
        var itemRemoved = this.state.selectedInstruments.filter(
          (d: any) => !values.map((x: any) => x.value).includes(d.value)
        );
        instrumentToBeRemoved = itemRemoved[0].label;
      }
    }
    this._tempDropdownInstruments = values;

    if (instrumentToBeRemoved !== "") {
      this.setState(
        {
          instrumentToBeRemoved,
        },
        () => {
          this.setState({
            modalVisibleInstrument: true,
          });
        }
      );
    } else {
      this.UpdateSelectedInstruments(this._tempDropdownInstruments);
    }
  };

  private UpdateSelectedInstruments(values: any) {
    this.setState(
      {
        selectedInstruments: values,
        selectedCalculatedProperties: [],
        testplanFormData: {
          ...this.state.testplanFormData,
          selectedInstruments: values
        }
      },
      () => {
        let instrumentPartitions = [...this.state.instrumentPartitions];
        if (this.state.selectedInstruments.length > 0) {
          // Find instruments to remove from Partition details
          var instrumentsToRemove = instrumentPartitions.filter(
            (d) =>
              !this.state.selectedInstruments.map((t: any) => t.value).includes(d.id)
          );
          instrumentsToRemove.forEach((item: any) => {
            var index = instrumentPartitions.indexOf(item);
            instrumentPartitions.splice(index, 1);
          });
          this.state.selectedInstruments.forEach((item: any) => {
            if (!instrumentPartitions.some((d) => d.id === item.value)) {
              const instrument = this._instrumentList.find(
                (d) => d.id === item.value
              );
              instrumentPartitions.push(instrument);
            }
          });
          const instrumentsToBeFetched: string[] = [];
          this.state.selectedInstruments.forEach((item: any) => {
            instrumentsToBeFetched.push(item.value);
          });
          instrumentActions
            .getSelected(instrumentsToBeFetched)
            .then(() => {
              const selectedTestplan = [
                {
                  label: this.state.selectedInstruments?.label,
                  value: this.state.selectedInstruments?.value,
                },
              ];
              const selectedInstruments: any[] = [];
              this._fetchedInstruments?.forEach(
                (instrument: IInstrumentViewData) => {
                  selectedInstruments.push({
                    label: instrument.name,
                    value: instrument.id,
                  });
                }
              );
              const properties: IPropertySpecification[] = [];
              const allProperties: IPropertySpecification[] = [];
              this._fetchedInstruments?.forEach(
                (i: IInstrumentViewData) => {
                  i.properties.forEach((p: any) => {
                    const direction =
                      p.direction.name != CONSTANTS.ND
                        ? p.direction.name
                        : "";
                    const pName =
                      p.name + " (" + i.codeId + ")" + direction;
                    const max =
                      p.max === null || p.max === 0
                        ? ""
                        : String(p.max);
                    const min =
                      p.min === null || p.min === 0
                        ? ""
                        : String(p.min);
                    properties.push(
                      new PropertySpecification(
                        true,
                        false,
                        i.id,
                        p.id,
                        pName,
                        p.customId,
                        "",
                        "",
                        1,
                        0,
                        min,
                        max,
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        [],
                        p.direction
                      )
                    );
                    allProperties.push(
                      new PropertySpecification(
                        true,
                        false,
                        i.id,
                        p.id,
                        pName,
                        p.customId,
                        "",
                        "",
                        1,
                        0,
                        min,
                        max,
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        [],
                        p.direction
                      )
                    );
                  });
                }
              );
              this.setState({
                measuredProperty: properties,
                testplanFormData: {
                  ...this.state.testplanFormData,
                  properties: [...this.state.keyedInProperty, ...properties],
                  allProperties: [...this.state.keyedInProperty, ...properties],
                },
              }, () => {
                this.validate();
                this._testplanproperties = properties;
                const calculatedIds: string[] = [];
                this.state.testplanFormData.properties.map(
                  (id, index) => {
                    calculatedIds.push(id.propertyId);
                  }
                );

                propertyActions
                  .getSelectedCalculated(calculatedIds)
                  .then(() => {
                    const calculatedDropdownList: any[] = [];
                    this._fetchedCalculatedProperties.forEach(
                      (element: IPropertyViewData) => {
                        calculatedDropdownList.push({
                          label: element?.name,
                          value: element?.id,
                        });
                      }
                    );
                    this.setState({
                      calculatedDropdownList,
                      allCalculatedDropdownList:
                        calculatedDropdownList,
                      testplanFormData: {
                        ...this.state.testplanFormData,
                        allCalculatedDropdownList: calculatedDropdownList
                      }
                    });
                  });
              });
            })
            .catch((error) => {
              triggerNotifications
                .errors(error.message, error.data)
                .then();
            });
        } else {
          instrumentPartitions = [];
          this.setState({
            calculatedDropdownList: [],
            allCalculatedDropdownList: [],
            selectedCalculatedProperties: [],
            measuredProperty: [],
            testplanFormData: {
              ...this.state.testplanFormData,
              properties: [...this.state.keyedInProperty],
              selectedCalculatedProperties: [],
              calculatedProperties: []
            }
          })
        }

        const selectedToggle =
          instrumentPartitions.length > 0
            ? [0]
            : this.state.selectedKeyedInProperties.length > 0
              ? [1]
              : [0];

        this.setState({
          instrumentPartitions,
          selectedToggle,
          testplanFormData: {
            ...this.state.testplanFormData,
            instruments: instrumentPartitions
          }
        });
      }
    );
  }

  private performInstrumentSelectionChange = () => {
    this.setState(
      {
        modalVisibleInstrument: false,
      },
      () => {
        this.UpdateSelectedInstruments(this._tempDropdownInstruments);
      }
    );
  };

  private keyedInPropertyChangeHandler = (values: any) => {
    let keyedInPropertyToBeRemoved = "";
    if (values.length === 0) {
      keyedInPropertyToBeRemoved =
        this.state.selectedKeyedInProperties[0].label;
    } else {
      if (
        this.state.selectedKeyedInProperties.some(
          (d) => !values.map((x: any) => x.value).includes(d.value)
        )
      ) {
        var itemRemoved = this.state.selectedKeyedInProperties.filter(
          (d) => !values.map((x: any) => x.value).includes(d.value)
        );
        keyedInPropertyToBeRemoved = itemRemoved[0].label;
      }
    }

    this._tempDropdownKeyedIns = values;

    if (keyedInPropertyToBeRemoved !== "") {
      this.setState(
        {
          keyedInPropertyToBeRemoved,
        },
        () => {
          this.setState({
            modalVisibleProperty: true,
          });
        }
      );
    } else {
      this.UpdateSelectedKeyedInProperties(this._tempDropdownKeyedIns);
    }
  };

  private UpdateSelectedKeyedInProperties(values: any[]) {
    this.setState(
      {
        selectedKeyedInProperties: values,
        selectedCalculatedProperties: [],
        testplanFormData: {
          ...this.state.testplanFormData,
          selectedKeyedInProperties: values,
        }
      },
      () => {
        let keyedInPartitions = [...this.state.keyedInPartitions];

        if (this.state.selectedKeyedInProperties.length > 0) {
          // Find instruments to remove from Partition details
          var KeyedInToRemove = keyedInPartitions.filter(
            (d) =>
              !this.state.selectedKeyedInProperties
                .map((t) => t.value)
                .includes(d.id)
          );

          KeyedInToRemove.forEach((item: any) => {
            var index = keyedInPartitions.indexOf(item);
            keyedInPartitions.splice(index, 1);
          });

          this.state.selectedKeyedInProperties.forEach((item: any) => {
            if (!keyedInPartitions.some((d) => d.id === item.value)) {
              const keyedInProperty = this._keyedInPropertyList.find(
                (d) => d.id === item.value
              );
              keyedInPartitions.push(keyedInProperty);
            }
          });
          const propertiesToBeFetched: string[] = [];
          this.state.selectedKeyedInProperties.forEach(
            (property: any) => {
              propertiesToBeFetched.push(property.value);
            }
          );
          const properties: IPropertySpecification[] = [];
          const allProperties: IPropertySpecification[] = [];
          propertyActions
            .getSelected(propertiesToBeFetched)
            .then(() => {
              this._fetchedProperties.forEach(
                (p: IPropertyViewData) => {
                  properties.push(
                    new PropertySpecification(
                      false,
                      false,
                      "",
                      p.id,
                      p.name,
                      p.customId,
                      "",
                      "",
                      1,
                      0,
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      []
                    )
                  );
                  allProperties.push(
                    new PropertySpecification(
                      false,
                      false,
                      "",
                      p.id,
                      p.name,
                      p.customId,
                      "",
                      "",
                      1,
                      0,
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      []
                    )
                  );
                }
              );
              this.setState({
                keyedInProperty: properties,
                testplanFormData: {
                  ...this.state.testplanFormData,
                  properties: [...this.state.measuredProperty, ...properties],
                  allProperties:  [...this.state.measuredProperty, ...properties],
                },
              }, () => {
                this.validate();
                const calculatedIds: string[] = [];
                this.state.testplanFormData.properties.map(
                  (id, index) => {
                    calculatedIds.push(id.propertyId);
                  }
                );

                propertyActions
                  .getSelectedCalculated(calculatedIds)
                  .then(() => {
                    const calculatedDropdownList: any[] = [];
                    this._fetchedCalculatedProperties.forEach(
                      (element: IPropertyViewData) => {
                        calculatedDropdownList.push({
                          label: element?.name,
                          value: element?.id,
                        });
                      }
                    );
                    this.setState({
                      calculatedDropdownList,
                      allCalculatedDropdownList:
                        calculatedDropdownList,
                      testplanFormData: {
                        ...this.state.testplanFormData,
                        allCalculatedDropdownList:
                          calculatedDropdownList,
                      }
                    }, () => {
                      const selectedToggle =
                        keyedInPartitions.length > 0
                          ? [1]
                          : this.state.selectedInstruments.length > 0
                            ? [0]
                            : [1];

                      this.setState({
                        keyedInPartitions,
                        selectedToggle,
                        activeTab: 0,
                        testplanFormData: {
                          ...this.state.testplanFormData,
                          keyedInPartitions,
                        }
                      });
                    });
                  });
              });
            })
            .catch((error) => {
              triggerNotifications
                .errors(error.message, error.data)
                .then();
            });
        } else {
          keyedInPartitions = [];
          this.setState({
            calculatedDropdownList: [],
            allCalculatedDropdownList: [],
            selectedCalculatedProperties: [],
            keyedInProperty: [],
            testplanFormData: {
              ...this.state.testplanFormData,
              properties: [...this.state.measuredProperty],
              selectedCalculatedProperties: [],
              calculatedProperties: []
            },
          }, () => {
            const selectedToggle =
              keyedInPartitions.length > 0
                ? [1]
                : this.state.selectedInstruments.length > 0
                  ? [0]
                  : [1];

            this.setState({
              keyedInPartitions,
              selectedToggle,
              activeTab: 0,
              testplanFormData: {
                ...this.state.testplanFormData,
                keyedInPartitions,
              }
            });
          })
        }
      }
    );
  }

  private sourceChangeHandler = (val: any) => {
    this.setState(
      {
        selectedSource: val,
        globalStripLength: val[0].value[0],
        testplanFormData: {
          ...this.state.testplanFormData,
          selectedSource: val,
        }
      },
      () => {
        if (
          this.state.testplanFormData.isEditMode &&
          !this.state.isGlobalEditConfirm
        ) {
          this.setState({
            editGlobalValuesModalVisible: true,
            globalEditMode: "StripLength",
            editedInput: Number(val[0].value[0]),
          });
          return;
        }
        // update strip length at global level
        let instrumentPartitions = [...this.state.instrumentPartitions];
        this.state.instrumentPartitions.forEach((data: any, index: number) => {
          let instrument = { ...instrumentPartitions[index] };
          const lengthVal = val[0].value[0].toString().split(".").join("");
          TestplanInstrumentOperations.setInstrumentStripLength(
            instrument,
            Number(lengthVal)
          );
          instrumentPartitions[index] = instrument;
        });
        this.setState({
          instrumentPartitions,
          globalStripLength: Number(val[0].value[0]),
          editGlobalValuesModalVisible: false,
          globalEditMode: "",
          testplanFormData: {
            ...this.state.testplanFormData,
            instruments: instrumentPartitions
          }
        });
      }
    );
  };
  private performKeyedInPropertySelectionChange = () => {
    this.setState(
      {
        modalVisibleProperty: false,
      },
      () => {
        this.UpdateSelectedKeyedInProperties(this._tempDropdownKeyedIns);
      }
    );
  };
  private onChangeType(v: string): void {
    this.setPDC(v);
  }

  private onChange(v: any): void {
    this.setState({
      isSelectStripLength: v,
      testplanFormData: {
        ...this.state.testplanFormData,
        isSelectStripLength: v,
      }
    });
  }

  onCancelClick = () => {
    history.push(CONSTANTS.TESTPLAN_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  private calculateChangeHandler = (value: any) => {
    const calculatedDetailsIds: string[] = [];
    value.map((id: any) => {
      calculatedDetailsIds.push(id.value);
    });
    if (calculatedDetailsIds.length > 0) {
      calculatedPropertyActions
        .getSelected(calculatedDetailsIds, null)
        .then(() => {
          let sourceMappings: any[] = [];
          let properties: IPropertySpecification[] = [];
          if (this.state.testplanFormData.properties !== undefined) {
            properties = [
              ...this.state.testplanFormData.properties.filter(
                (x) => !x.isCalculated
              ),
            ];
          }
          // Pushing calculated properties to table
          if (value.length > 0) {
            value.forEach((item: any) => {
              const property = properties.find(
                (x) => x.propertyId === item.value
              );
              if (property === undefined) {
                this._calculatedPropertyDetails.forEach(
                  (c: ICalculatedPropertyViewData) => {
                    if (item.value === c.id) {
                      sourceMappings = [];
                      c.variables.map(
                        (sourceData: IVariableData, index: any) => {
                          sourceMappings.push({
                            sourceId: "",
                            valueId: "",
                            position: "",
                            propertyId: sourceData.property.id,
                            propertyAttributeId: sourceData.attribute.id,
                            variable: sourceData.variable,
                            calculatedId: c.id,
                          });
                          c.onSourceDropdownAsPerAttribute(
                            sourceData.attribute.name,
                            index
                          );
                        }
                      );
                      const customId = this._fetchedCalculatedProperties.find(
                        (item) => {
                          return item.id == c.id;
                        }
                      );
                      properties.push(
                        new PropertySpecification(
                          false,
                          true,
                          "",
                          c.id,
                          c.name,
                          customId.customId,
                          "",
                          "",
                          1,
                          0,
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          sourceMappings
                        )
                      );
                    }
                  }
                );
              } else {
                properties.push(property);
              }
            });
            // update the properties order number in create mode
            if (!this.state.testplanFormData.isEditMode) {
              for (let i = 0; i < properties.length; i++) {
                properties[i].order = i + 1;
              }
            }
          }

          this.setState(
            {
              calculatedPropertyDetails: this._calculatedPropertyDetails,
              selectedCalculatedProperties: value,
              testplanFormData: {
                ...this.state.testplanFormData,
                sourceMappings,
                properties,
                selectedCalculatedProperties: value,
                calculatedProperties: value
              },
              isNext: true,
            },
            () => {
              this.validate()
              if (!this.state.testplanFormData.showGrade) {
                this.onNextClick()
              }
            }
          );
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      const properties = this.state.testplanFormData.properties.filter(
        (x) => x.isCalculated !== true
      );

      this.setState(
        {
          calculatedPropertyDetails: [],
          selectedCalculatedProperties: value,
          isNext: false,
          testplanFormData: {
            ...this.state.testplanFormData,
            properties,
            showformula: false,
            selectedCalculatedProperties: value,
            calculatedProperties: value
          },
        },
        () => {
          this.validate()
          if (!this.state.testplanFormData.showGrade) {
            this.onNextClick()
          }
        }
      );
    }
  };

  getAllCalculatedPropertiesEdit = () => {
    const calculatedIds: string[] = [];

    this.state.testplanFormData.properties.map((id, index) => {
      calculatedIds.push(id.propertyId);
    });
    propertyActions.getSelectedCalculated(calculatedIds).then(() => {
      const allCalculatedDropdownList: any[] = [];
      this._fetchedCalculatedProperties.forEach(
        (element: IPropertyViewData) => {
          allCalculatedDropdownList.push({
            label: element.name,
            value: element.id,
            disabled: false,
          });
        }
      );
      this.setState({
        allCalculatedDropdownList,
        testplanFormData: {
          ...this.state.testplanFormData,
          allCalculatedDropdownList
        }
      });
    });
  };

  getCalculatedPropertiesEdit = () => {
    const calculatedIds: string[] = [];

    this.state.testplanFormData.properties.map((id, index) => {
      calculatedIds.push(id.propertyId);
    });

    propertyActions.getSelectedCalculated(calculatedIds).then(() => {
      const calculatedDropdownList: any[] = [];
      const calculatedList: any[] = [];
      let fetchedCalculatedProperties: any[] = [];
      this._fetchedCalculatedProperties.forEach(
        (element: IPropertyViewData) => {
          calculatedDropdownList.push({
            label: element.name,
            value: element.id,
          });
          calculatedList.push(element.id);

          fetchedCalculatedProperties.push(
            new PropertySpecification(
              false,
              true,
              "",
              element.id,
              element.name,
              element.customId,
              "",
              "",
              1,
              0,
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              []
            )
          );
        }
      );

      const removeCalculatedPropertiesList =
        this.state.testplanFormData.properties.filter((obj) => !obj.isCalculated);
      const arr: any = [
        ...removeCalculatedPropertiesList,
        ...fetchedCalculatedProperties,
      ];

      // All values of calculated dropdownlist
      const allCalculatedDropdownList =
        this.state.allCalculatedDropdownList.map((item: any) => {
          if (calculatedList.includes(item.value)) {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
          return item;
        });

      this.setState({
        allCalculatedDropdownList,
        selectedCalculatedProperties: calculatedDropdownList,
        testplanFormData: {
          ...this.state.testplanFormData,
          properties: arr,
          allCalculatedDropdownList,
          selectedCalculatedProperties: calculatedDropdownList,
          calculatedProperties: calculatedDropdownList
        },
      });
    });
  };

  public render() {
    const commonProps = {
      activeTab: this.state.activeTab,
      onTabChange: (oldIndex: any, newIndex: any) =>
        this.setState({ activeTab: newIndex }),
    };
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll-height">
            <div className="layout-container">
              <SubmitHeader
                name={t(CONSTANTS.MODULE_TESTPLAN)}
                link="manageinstrument/testplan"
                isEdit={this.state.testplanFormData?.isEditMode}
                onSaveClick={this.onSaveClick}
                onCreateClick={this.onCreateClick}
                onCancelClick={this.onCancelClick}
                isLoading={this.state.formLoading}
              />
              <div className="mt-4">
                <div className="col-md-6 no-padding float-left">
                  <div className="box box-height-tp">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(
                          CONSTANTS.MODULE_TESTPLAN +
                          " " +
                          CONSTANTS.TITLE_TESTOVERVIEW_DETAILS
                        )}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-2">
                      <div className="col-sm col-md">
                        <Input
                          inputAttributes={{ autoFocus: "true" }}
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          label={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          className={
                            this.state.nameError
                              ? "error-code mt-2 w-50"
                              : "mt-2 w-50"
                          }
                          value={String(this.state.testplanFormData?.name)}
                          onValueChange={this.setName}
                          maxLength={250}
                          showValidationBarWhenInvalid={this.state.nameError}
                          description={
                            this.state.nameError
                              ? this.state.testplanFormData.name.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-sm col-md">
                        <Input
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          inputAttributes={{ rows: "4" }}
                          className="mt-2 h-25"
                          resizable={false}
                          value={String(
                            this.state.testplanFormData?.description
                          )}
                          onValueChange={this.setDescription}
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="box-below-information">
                      {200 - this.state.testplanFormData?.description?.length}{" "}
                      {t("character left out of 200 character")}
                    </div>
                  </div>
                </div>

                <div className="col-md-6 no-padding float-left">
                  <div className="box box-height-tp ml-3 ">
                    <div className="box-circle">
                      <p className="box-circle-text"> 2 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-2">
                      <div className="col-sm-12 col-md-12">
                        <label className="dropdown-common-label">
                          {t(CONSTANTS.LABEL_SELECT) +
                            " " +
                            t(CONSTANTS.MODULE_INSTRUMENT)}
                        </label>
                        <span
                          style={{
                            paddingLeft: "4px",
                            verticalAlign: "middle",
                          }}
                        >
                          <WithTooltip>
                            <Icon
                              name={ICONCONSTANTS.ABB_INFORMATION}
                              sizeClass="small"
                              className="blue-color cursor-pointer"
                            />
                            <Tooltip>
                              <p>{t(CONSTANTS.INST_ORDER_TESTPLAN)}</p>
                            </Tooltip>
                          </WithTooltip>
                        </span>
                        <Dropdown
                          multiselect={true}
                          clearable={false}
                          placeholder={
                            t(CONSTANTS.LABEL_PICK) +
                            " " +
                            t(CONSTANTS.MODULE_INSTRUMENT)
                          }
                          searchable={true}
                          value={this.state.selectedInstruments}
                          onChange={this.instrumentChangeHandler}
                        >
                          {this.state.instrumentList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-sm-12 col-md-12">
                        <label className="dropdown-common-label">
                          {t(CONSTANTS.LABEL_SELECT) +
                            " " +
                            t(CONSTANTS.KEYED_IN) +
                            " " +
                            t(CONSTANTS.LABEL_PROPERTIES)}
                        </label>
                        <span
                          style={{
                            paddingLeft: "4px",
                            verticalAlign: "middle",
                          }}
                        >
                          <WithTooltip>
                            <Icon
                              name={ICONCONSTANTS.ABB_INFORMATION}
                              sizeClass="small"
                              className="blue-color cursor-pointer"
                            />
                            <Tooltip>
                              <p>{t(CONSTANTS.KEYED_ORDER_TESTPLAN)}</p>
                            </Tooltip>
                          </WithTooltip>
                        </span>
                        <Dropdown
                          multiselect={true}
                          clearable={false}
                          placeholder={
                            t(CONSTANTS.LABEL_PICK) +
                            " " +
                            t(CONSTANTS.KEYED_IN) +
                            " " +
                            t(CONSTANTS.LABEL_PROPERTIES)
                          }
                          searchable={true}
                          value={this.state.selectedKeyedInProperties}
                          onChange={this.keyedInPropertyChangeHandler}
                        >
                          {this.state.keyedInPropertyList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    {((this.state.testplanFormData.isEditMode &&
                      this.state.testplanFormData.isGradeCreatedWithTP === 0)
                      || (!this.state.testplanFormData.isEditMode)) && (<div className="row mt-2">
                        <div className="col-sm-12 col-md-12">
                          <CalculatedProperty
                            selectedCalculatedProperties={this.state.selectedCalculatedProperties}
                            calculateChangeHandler={this.calculateChangeHandler}
                            allCalculatedDropdownList={this.state.allCalculatedDropdownList}
                          />
                        </div>
                      </div>)}

                    <div className="row mt-2">
                      <label
                        className="col-4 dropdown-common-label"
                        style={{ marginRight: "10px", marginTop: "6px" }}
                      >
                        {t(CONSTANTS.LABEL_CHOOSE_STRIP_LENGTH)}
                      </label>
                      <ToggleSwitch
                        showIcons={true}
                        className="spinner-position"
                        value={this.state.isSelectStripLength}
                        onChange={(value: any) => this.onChange(value)}
                      />
                    </div>

                    {this.state.isSelectStripLength && (
                      <div className="row mt-2">
                        <div className="col-sm-12 col-md-12">
                          <label className="dropdown-common-label">
                            {t(CONSTANTS.LABEL_SELECT) +
                              " " +
                              t(CONSTANTS.MENU_SOURCE)}
                          </label>
                          <span
                            style={{
                              paddingLeft: "4px",
                              verticalAlign: "middle",
                            }}
                          >
                            <WithTooltip>
                              <Icon
                                name={ICONCONSTANTS.ABB_INFORMATION}
                                sizeClass="small"
                                className="blue-color cursor-pointer"
                              />
                              <Tooltip>
                                <p>{t(CONSTANTS.KEYED_ORDER_TESTPLAN)}</p>
                              </Tooltip>
                            </WithTooltip>
                          </span>
                          <Dropdown
                            multiselect={false}
                            clearable={false}
                            placeholder={
                              t(CONSTANTS.LABEL_PICK) +
                              " " +
                              t(CONSTANTS.MENU_SOURCE)
                            }
                            searchable={true}
                            value={this.state.selectedSource}
                            onChange={this.sourceChangeHandler}
                          >
                            {this._sourceList.map((o) => (
                              <DropdownOption
                                key={o.value}
                                label={o.label}
                                value={[o.stripLength, o.value]}
                              />
                            ))}
                          </Dropdown>
                        </div>
                      </div>
                    )}

                    <p
                      className="mt-3"
                      style={{ fontSize: "16px", marginBottom: "0px" }}
                    >
                      {t("Global Settings")}
                      <span
                        style={{ paddingLeft: "4px", verticalAlign: "middle" }}
                      >
                        <WithTooltip>
                          <Icon
                            name={ICONCONSTANTS.ABB_INFORMATION}
                            sizeClass="small"
                            className="blue-color cursor-pointer"
                          />
                          <Tooltip>
                            <p>{t(CONSTANTS.GLOBAL_POSITION_COUNT_INFO)}</p>
                            <p>
                              {t(CONSTANTS.GLOBAL_POSITION_COUNT_DEFAULT_VALUE)}
                            </p>
                          </Tooltip>
                        </WithTooltip>
                      </span>
                    </p>
                    <hr className="hr-line mb-2" />
                    <div className="row">
                      <div className="col-sm-4 col-md-4">
                        <NumericInput
                          type="normal"
                          style={{ minWidth: "160px" }}
                          label={t(CONSTANTS.GLOBAL_NO_OF_POSITION)}
                          value={
                            !this.state.isAllPositionsEqual
                              ? this.state.globalPositionInput
                              : this.state.globalPositionInput
                          }
                          min={1}
                          max={999}
                          step={1}
                          allowClear={true}
                          disableEdit={false}
                          onChange={(value: number) =>
                            this.inputNumberOfGlobalPosition(value)
                          }
                        />
                        {!this.state.isAllPositionsEqual ? (
                          <span className="note">
                            * {t("All position values not equal")}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-4 col-md-4">
                        <NumericInput
                          type="normal"
                          label={t(CONSTANTS.GLOBAL_NO_OF_COUNT)}
                          value={
                            !this.state.isAllCountsEqual
                              ? this.state.globalCountInput
                              : this.state.globalCountInput
                          }
                          min={1}
                          max={99}
                          step={1}
                          disableEdit={false}
                          allowClear={true}
                          onChange={(value: number) =>
                            this.inputNumberOfGlobalCount(value)
                          }
                        />
                        {!this.state.isAllCountsEqual ? (
                          <span className="note">
                            * All count values not equal
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-4 col-md-4">
                        <Input
                          dataType="number"
                          label={t(CONSTANTS.GLOBAL_SAMPLE_STRIP_LENGTH)}
                          onValueChange={(value: string) =>
                            this.inputGlobalStripLength(value)
                          }
                          type="normal"
                          style={{ width: "200px" }}
                          value={
                            this.state.testplanFormData?.isEditMode &&
                              !this.state.isAllStripLengthEqual
                              ? ""
                              : String(this.state.globalStripLength)
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-2">
                      <label className="dropdown-common-label">
                        {t(CONSTANTS.LABEL_MEASUREMENT_ORDER)}
                      </label>
                      <div className="radio-margins">
                        <RadioGroup
                          sizeClass={"small"}
                          orientation={"horizontal"}
                          onChange={(v) => this.onChangeType(v)}
                          value={
                            this.state.testplanFormData?.isPDC === true
                              ? "0"
                              : "1"
                          }
                        >
                          <RadioOption
                            text={t(CONSTANTS.LABEL_DIRECTION + " (DPC)")}
                            value={"1"}
                          />
                          <RadioOption
                            text={t(CONSTANTS.LABEL_POSITION + " (PDC)")}
                            value={"0"}
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              {(this.state.instrumentPartitions.length !== 0 ||
                this.state.selectedKeyedInProperties.length !== 0) ? (
                <div>
                  <div className="col-md-12 no-padding">
                    <div className="box-1 h-100 mb-4">
                      <div className="box-circle">
                        <p className="box-circle-text"> 3 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">
                          {t(CONSTANTS.MODULE_TESTPLAN) +
                            " " +
                            t(CONSTANTS.TITLE_TESTOVERVIEW_CONFIGURATION)}
                        </p>
                      </div>
                      <hr className="hr-line" />

                      <div style={{ textAlign: "center", paddingTop: "5px" }}>
                        <ToggleButtonGroup
                          selected={this.state.selectedToggle}
                          onChange={(v) => this.onToggle(v)}
                          sizeClass="medium"
                        >
                          <ToggleButton
                            text={t(CONSTANTS.MEASURED)}
                            disabled={
                              this.state.instrumentPartitions.length === 0
                            }
                          />
                          <ToggleButton
                            text={t(CONSTANTS.KEYED_IN)}
                            disabled={this.state.keyedInPartitions.length === 0}
                          />
                        </ToggleButtonGroup>
                      </div>

                      {this.state.selectedToggle.includes(1) ? (
                        <div className="tab-scroll">
                          <TabControl
                            type="primary"
                            {...commonProps}
                            activeTab={this.state.activeTab}
                          >
                            {this.state.keyedInPartitions.map(
                              (keyedInProperty: IKeyedInProperty, index) => (
                                <TabItem
                                  title={keyedInProperty.name}
                                  key={index}
                                >
                                  <InputPosition
                                    screenKey={TestPlanScreen.KeyedInProperty}
                                    isCreate={true}
                                    isShowFixed={false}
                                    isClone={false}
                                    isStripLength={false}
                                    index={index}
                                    keyedInPropertyState={keyedInProperty}
                                    inputNumberOfPosition={(val: string) =>
                                      this.inputNumberOfPositionHandler(
                                        val,
                                        index
                                      )
                                    }
                                  />
                                  <PositionBar
                                    id={`keyedInPositionBar-${index}`}
                                    list={keyedInProperty.partitions}
                                  >
                                    {keyedInProperty.partitions.map(
                                      (
                                        partition: IKeyedInPartition,
                                        index: number
                                      ) =>
                                        partition.isEdit ? (
                                          <KeyedInEditablePartition
                                            key={index}
                                            keyedInProperty={keyedInProperty}
                                            directions={this._directionList}
                                            partition={partition}
                                            onDelete={
                                              this.deleteKeyedInPartition
                                            }
                                            onCancel={
                                              this.onCancelKeyedInPartition
                                            }
                                            onSave={this.onSaveKeyedInPartition}
                                            countValidate={(
                                              value,
                                              direction,
                                              partition,
                                              index
                                            ) =>
                                              this.countValidate(
                                                value,
                                                direction,
                                                partition,
                                                index
                                              )
                                            }
                                          />
                                        ) : (
                                          <KeyedInPartition
                                            key={index}
                                            partition={partition}
                                            keyedInProperty={keyedInProperty}
                                            editToggle={this.editKeyedInToggle}
                                          />
                                        )
                                    )}
                                  </PositionBar>
                                </TabItem>
                              )
                            )}
                          </TabControl>
                        </div>
                      ) : (
                        <div className="tab-scroll">
                          <TabControl
                            type="primary"
                            {...commonProps}
                            activeTab={this.state.activeTab}
                          >
                            {this.state.instrumentPartitions.map(
                              (
                                instrumentDetail: ITestPlanInstrument,
                                index: number
                              ) =>
                                instrumentDetail.isAutoline ? (
                                  <TabItem
                                    title={instrumentDetail.name}
                                    key={index}
                                  >
                                    <NoDataFound
                                      moduleName={t(CONSTANTS.MODULE_TESTPLAN)}
                                      message={t(CONSTANTS.AUTOLINE_MESSAGE)}
                                    />
                                  </TabItem>
                                ) : (
                                  <TabItem
                                    title={instrumentDetail.name}
                                    key={index}
                                  >
                                    <InputPosition
                                      screenKey={TestPlanScreen.Instrument}
                                      isCreate={true}
                                      isClone={false}
                                      isShowFixed={true}
                                      isStripLength={true}
                                      index={index}
                                      instrumentState={instrumentDetail}
                                      inputFixedPosition={(val: string) =>
                                        this.inputFixedPositionHandler(
                                          val,
                                          index
                                        )
                                      }
                                      inputStripLength={(val: string) =>
                                        this.inputStripLengthHandler(val, index)
                                      }
                                      inputNumberOfPosition={(val: string) =>
                                        this.inputNumberOfPositionHandler(
                                          val,
                                          index
                                        )
                                      }
                                      isFixedPositionHandler={(val) =>
                                        this.isFixedPositionHandler(
                                          !instrumentDetail.isFixedPosition,
                                          index
                                        )
                                      }
                                    />
                                    <PositionBar
                                      id={`measuredPositionBar-${index}`}
                                      list={instrumentDetail.partitions}
                                    >
                                      {instrumentDetail.partitions.map(
                                        (partition, index) =>
                                          partition.isEdit ? (
                                            <MeasuredEditablePartition
                                              key={index}
                                              instrument={instrumentDetail}
                                              partition={partition}
                                              onDelete={
                                                this.deleteMeasuredPartition
                                              }
                                              onSave={
                                                this.saveMeasuredPartition
                                              }
                                              onCancel={
                                                this.cancelEditMeasuredPartition
                                              }
                                              showError={this.error}
                                              countValidate={(
                                                value,
                                                direction,
                                                partition,
                                                index
                                              ) =>
                                                this.countValidate(
                                                  value,
                                                  direction,
                                                  partition,
                                                  index
                                                )
                                              }
                                            />
                                          ) : (
                                            <MeasuredPartition
                                              key={index}
                                              instrument={instrumentDetail}
                                              partition={partition}
                                              editToggle={
                                                this.editInstrumentToggle
                                              }
                                            />
                                          )
                                      )}
                                    </PositionBar>
                                  </TabItem>
                                )
                            )}
                          </TabControl>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
              {(this.state.selectedInstruments.length !== 0 || this.state.selectedKeyedInProperties.length !== 0)
                && !this.state.testplanFormData.isEditMode && (<><div className="float-right mt-2" style={{ marginRight: "1rem" }}>
                  <Authorize scopes={[`${CONSTANTS.AUTHKEY_GRADE}:Add`]}>
                    <Button
                      type="primary-blue"
                      text={this.state.testplanFormData.showGrade ? `${t(CONSTANTS.REMOVE_GRADE)}` : `${t(CONSTANTS.ADD_GRADE)}`}
                      onClick={this.onAddGradeClick}
                    />
                  </Authorize>
                </div>
                  <div className="clearfix" /></>)}
              {(this.state.selectedCalculatedProperties.length !== 0 || this.state.testplanFormData.showGrade) &&
                (this.state.selectedInstruments.length !== 0 || this.state.selectedKeyedInProperties.length !== 0) ? (
                <div>
                  <div className="col-md-12 no-padding">
                    <div className="box-1 h-100 mb-4">
                      <div className="box-circle">
                        <p className="box-circle-text"> 4 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">
                          {this.state.testplanFormData.showGrade ? `${t(CONSTANTS.LABEL_GRADE_QUALITY_SPECIFICATIONS)}` : `${t(CONSTANTS.LABEL_PROPERTIES)}`}
                        </p>
                      </div>
                      <hr className="hr-line" />
                      {this.state.selectedCalculatedProperties.length !== 0 && this.state.testplanFormData.showGrade ? (
                        <PropertySteps isStep={this.state.isStep} />
                      ) : null}

                      {this.state.testplanFormData.showGrade && !this.state.testplanFormData.showformula && (
                        <>
                          <div className="mt-4">
                            <div className="col-6 no-padding float-left">
                              <div className="row mt-3">
                                <div className="col-sm col-md">
                                  <Input
                                    inputAttributes={{ autoFocus: "true" }}
                                    className={
                                      this.state.gradeCodeError
                                        ? "error-code mt-2 w-50"
                                        : "mt-2 w-50"
                                    }
                                    dataType="text"
                                    label={t(CONSTANTS.LABLE_GRADE_CODE)}
                                    placeholder={t(CONSTANTS.LABLE_GRADE_CODE)}
                                    // required={true}
                                    value={this.state.testplanFormData.gradeCode}
                                    onValueChange={this.setGradeCode}
                                    maxLength={10}
                                    showValidationBarWhenInvalid={this.state.gradeCodeError}
                                    description={
                                      this.state.gradeCodeError
                                        ? this.state.testplanFormData.gradeCode.length
                                          ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                          : t(CONSTANTS.FIELD_EMPTY_ERROR)
                                        : ""
                                    }
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm col-md">
                                  <Input
                                    dataType="text"
                                    placeholder={t(CONSTANTS.LABLE_GRADE_NAME)}
                                    label={t(CONSTANTS.LABLE_GRADE_NAME)}
                                    required={true}
                                    className={
                                      this.state.gradeNameError
                                        ? "error-code mt-2 w-50"
                                        : "mt-2 w-50"
                                    }
                                    value={this.state.testplanFormData.gradeName}
                                    onValueChange={this.setGradeName}
                                    maxLength={250}
                                    showValidationBarWhenInvalid={this.state.gradeNameError}
                                    description={
                                      this.state.gradeNameError
                                        ? this.state.testplanFormData.gradeName.length
                                          ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                          : t(CONSTANTS.FIELD_EMPTY_ERROR)
                                        : ""
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 no-padding float-left">
                              <div className="row mt-3">
                                <div className="col-sm-7 col-md-7">
                                  <Input
                                    className="mt-2 w-100"
                                    dataType="text"
                                    label={t(CONSTANTS.LABEL_PROPERTIES)}
                                    placeholder={t(CONSTANTS.NO_PROPERTIES_SELECTED)}
                                    required={true}
                                    value={
                                      this.state.testplanFormData.properties.length === 0
                                        ? t(CONSTANTS.NO_PROPERTIES_ASSOCIATED)
                                        : this.state.testplanFormData.properties.length ===
                                          1
                                          ? t(CONSTANTS.ONE_PROPERTY_ASSOCIATED)
                                          : `${String(
                                            this.state.testplanFormData.properties.length
                                          )}` +
                                          " " +
                                          t(CONSTANTS.PROPERTIES_ASSOCIATED)
                                    }
                                  />
                                </div>
                                <div className="col-sm-4 col-md-4 mt-4 pt-2">
                                  <Button
                                    sizeClass="small"
                                    type="discreet-blue"
                                    disabled={
                                      this.state.testplanFormData.properties.length === 0
                                    }
                                    className="associate-btn"
                                    text={t(CONSTANTS.SHOW_HIDE_PROPERTY)}
                                    onClick={this.associationAction}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="clearfix" />
                          </div>
                          <div className="sub-title ml-2 mt-2">
                            {t(CONSTANTS.LABEL_PROPERTIES)}
                          </div>
                          <PropertyTable
                            list={this.state.testplanFormData.properties}
                            onChangeValue={this.onChangeValue}
                            onBlurValue={this.onBlurValue}
                            setPropertiesOrderNo={this.setPropertiesOrderNo}
                            isNext={this.state.isNext}
                            onNextClick={this.onNextClick}
                          /></>
                      )}
                      {this.state.selectedCalculatedProperties.length !== 0 && (!this.state.testplanFormData.showGrade || this.state.testplanFormData.showformula) && (
                        <FormulaDefinitionTable
                          optionRef={this.optionRef}
                          onCloseAll={(value) => this.onCloseAll(value)}
                          onToggleClick={(value, index, i, calculatedId) =>
                            this.onToggleClick(value, index, i, calculatedId)
                          }
                          valueList={this.state.valueList}
                          calculatedPropertyDetails={this.state.calculatedPropertyDetails}
                          readingSourceList={this.state.readingSourceList}
                          oldPartitionName={this._oldPartitionName}
                          readingValuesList={this.state.readingValuesList}
                          partitionName={this._partitionName}
                          onSourceChangeHandler={(
                            value,
                            index,
                            i,
                            calculatedId
                          ) =>
                            this.onSourceChangeHandler(
                              value,
                              index,
                              i,
                              calculatedId
                            )
                          }
                          onValuesChangeHandler={(
                            value,
                            index,
                            i,
                            calculatedId
                          ) =>
                            this.onValuesChangeHandler(
                              value,
                              index,
                              i,
                              calculatedId
                            )
                          }
                          onPartitionChangeHandler={(
                            value,
                            index,
                            i,
                            calculatedId,
                            selectedElement
                          ) =>
                            this.onPartitionChangeHandler(
                              value,
                              index,
                              i,
                              calculatedId,
                              selectedElement
                            )
                          }
                          disableValueDropdown={this.state.disableValueDropdown}
                          disablePositionDropdown={this.state.disablePositionDropdown}
                          disableSourceDropdown={this.state.disableSourceDropdown}
                          onEditPartitionChange={(
                            value,
                            index,
                            i,
                            calculatedId
                          ) =>
                            this.onEditPartitionChange(
                              value,
                              index,
                              i,
                              calculatedId
                            )
                          }
                          thresholdvalue={this.thresholdvalue}
                          showGrade={this.state.testplanFormData.showGrade}
                          componentType="testPlan"
                          instrumentPartitions={this.state.instrumentPartitions}
                          keyedInPartitions={this.state.keyedInPartitions}
                          measuredProperty={this.state.measuredProperty}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            <Dialog
              isOpen={this.state.modalVisibleInstrument}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ modalVisibleInstrument: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={
                t(CONSTANTS.MODULE_INSTRUMENT) +
                " " +
                t(CONSTANTS.LABEL_SELECTION_CHANGE)
              }
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.performInstrumentSelectionChange,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.POSITION_CLEARED_MESSAGE) +
                  " " +
                  this.state.instrumentToBeRemoved}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.TESTPLAN_LOST_MESSAGE)}
              </div>
            </Dialog>

            <Dialog
              isOpen={this.state.modalVisibleNumberOfPosition}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() =>
                this.setState({ modalVisibleNumberOfPosition: false })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={
                t(CONSTANTS.KEYED_IN) +
                " " +
                t(CONSTANTS.MODULE_PROPERTY) +
                " " +
                t(CONSTANTS.LABEL_SELECTION_CHANGE)
              }
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: (dlg) => dlg.close(),
                },
              ]}
            >
              <div>
                {t(CONSTANTS.KEYEDIN_SELECTION_CHANGE_MESSAGE)}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.TESTPLAN_LOST_MESSAGE)}
              </div>
            </Dialog>

            <Dialog
              isOpen={this.state.modalVisibleProperty}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ modalVisibleProperty: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={
                t(CONSTANTS.KEYED_IN) +
                " " +
                t(CONSTANTS.MODULE_PROPERTY) +
                " " +
                t(CONSTANTS.LABEL_SELECTION_CHANGE)
              }
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.performKeyedInPropertySelectionChange,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.POSITION_CLEARED_MESSAGE) +
                  " " +
                  this.state.keyedInPropertyToBeRemoved}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.TESTPLAN_LOST_MESSAGE)}
              </div>
            </Dialog>

            <Dialog
              isOpen={this.state.editGlobalValuesModalVisible}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() =>
                this.setState({ editGlobalValuesModalVisible: false })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t("Global Edit Confirm ?")}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.handleGlobalEdit,
                },
              ]}
            >
              <div>
                {t(
                  "if you change the Positions, Counts and Strip length it will update globally."
                )}
                <br />
                {t(
                  "Are you sure you want to edit the Positions, Counts and Strip length ?"
                )}
              </div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }

  private deleteKeyedInPartition = (
    KeyedInProperty: IKeyedInProperty,
    partition: IKeyedInPartition
  ) => {
    let keyedInPartitions = [...this.state.keyedInPartitions];
    let keyedInDetail = keyedInPartitions.find(
      (d) => d.id === KeyedInProperty.id
    );
    const keyedInIndex = keyedInPartitions.findIndex(
      (d) => d.id === keyedInDetail.id
    );
    keyedInDetail.removePartition(partition);

    keyedInPartitions[keyedInIndex] = keyedInDetail;
    this.setState({
      keyedInPartitions,
      testplanFormData: {
        ...this.state.testplanFormData,
        keyedInPartitions
      }
    });
  };

  private onCancelKeyedInPartition = (
    KeyedInProperty: IKeyedInProperty,
    partition: IKeyedInPartition
  ) => {
    const keyedInPartitions = this.state.keyedInPartitions;
    partition.isEdit = false;
    const keyedInDetail = keyedInPartitions.find(
      (d) => d.id === KeyedInProperty.id
    );
    keyedInDetail.partitions[partition.index] = partition;
    const keyedInIndex = keyedInPartitions.findIndex(
      (d) => d.id === KeyedInProperty.id
    );
    keyedInPartitions[keyedInIndex] = keyedInDetail;

    this.setState({
      keyedInPartitions,
      testplanFormData: {
        ...this.state.testplanFormData,
        keyedInPartitions
      }
    });
  };

  private onSaveKeyedInPartition = (
    keyedInProperty: IKeyedInProperty,
    partition: IKeyedInPartition,
    partitionNameError: boolean,
    mode?: string
  ) => {
    let countDir: any[] = [];
    partition.directions.map((count) => {
      if (count.count === 0) {
        countDir.push(count.count);
      }
    });
    if (
      countDir.length === partition.directions.length &&
      partition.directions.length > 1
    ) {
      this.error(CONSTANTS.INVALID_COUNT);
    } else if (countDir.length > 0 && partition.directions.length <= 1) {
      this.error(CONSTANTS.INVALID_COUNT);
    } else {
      if (partitionNameError) {
        this.error("Position name cannot be blank");
      } else {
        const keyedInPartitions = this.state.keyedInPartitions;
        const keyedInDetail = keyedInPartitions.find(
          (d) => d.id === keyedInProperty.id
        );
        const keyedInIndex = keyedInPartitions.findIndex(
          (d) => d.id === keyedInProperty.id
        );
        keyedInDetail.updatePartition(partition);

        keyedInPartitions[keyedInIndex] = keyedInDetail;
        this.setState({
          keyedInPartitions,
          testplanFormData: {
            ...this.state.testplanFormData,
            keyedInPartitions
          }
        });
        //check global count value with individual keyedIn count
        if (mode !== "global") {
          this.setState({ isAllCountsEqual: true });
          partition.directions.forEach((value: any) => {
            if (value.count !== this._globalCOunt) {
              this.setState({ isAllCountsEqual: false });
              return;
            }
          });
        }
      }
    }
  };

  private cancelEditMeasuredPartition = (
    instrument: ITestPlanInstrument,
    partition: IInstrumentPartition
  ) => {
    const instrumentPartitions = this.state.instrumentPartitions;
    partition.isEdit = false;
    const instrumentDetail = instrumentPartitions.find(
      (d) => d.id === instrument.id
    );
    instrumentDetail.partitions[partition.index] = partition;
    const instrumentIndex = instrumentPartitions.findIndex(
      (d) => d.id === instrument.id
    );
    instrumentPartitions[instrumentIndex] = instrumentDetail;

    this.setState({
      instrumentPartitions,
      testplanFormData: {
        ...this.state.testplanFormData,
        instruments: instrumentPartitions
      }
    });
  };

  private saveMeasuredPartition = (
    instrument: ITestPlanInstrument,
    partition: IInstrumentPartition,
    partitionNameError: boolean,
    mode?: string
  ) => {
    let countDir: any[] = [];
    partition.directions.map((count) => {
      if (count.count === 0) {
        countDir.push(count.count);
      }
    });
    if (
      countDir.length === partition.directions.length &&
      partition.directions.length > 1
    ) {
      this.error(CONSTANTS.INVALID_COUNT);
    } else if (countDir.length > 0 && partition.directions.length <= 1) {
      this.error(CONSTANTS.INVALID_COUNT);
    } else {
      if (partitionNameError) {
        this.error("Position name cannot be blank");
      } else {
        const instrumentPartitions = this.state.instrumentPartitions;
        const instrumentDetail = instrumentPartitions.find(
          (d) => d.id === instrument.id
        ) as ITestPlanInstrument;
        const instrumentIndex = instrumentPartitions.findIndex(
          (d) => d.id === instrument.id
        );

        TestplanInstrumentOperations.updatePartition(
          instrumentDetail,
          partition
        );

        instrumentPartitions[instrumentIndex] = instrumentDetail;
        this.setState({
          instrumentPartitions,
          testplanFormData: {
            ...this.state.testplanFormData,
            instruments: instrumentPartitions
          }
        });
        //check global count value with individual measured count
        if (mode !== "global") {
          this.setState({ isAllCountsEqual: true });
          partition.directions.forEach((value: any) => {
            if (value.count !== this._globalCOunt) {
              this.setState({ isAllCountsEqual: false });
              return;
            }
          });
        }
      }
    }
  };

  private deleteMeasuredPartition = (
    instrument: ITestPlanInstrument,
    partition: IInstrumentPartition
  ) => {
    let instrumentPartitions = [...this.state.instrumentPartitions];
    let instrumentDetail = instrumentPartitions.find(
      (d) => d.id === instrument.id
    );
    const instrumentIndex = instrumentPartitions.findIndex(
      (d) => d.id === instrument.id
    );
    TestplanInstrumentOperations.removePartition(instrumentDetail, partition);
    instrumentPartitions[instrumentIndex] = instrumentDetail;
    this.setState({
      instrumentPartitions,
      testplanFormData: {
        ...this.state.testplanFormData,
        instruments: instrumentPartitions
      }
    });
  };

  private editInstrumentToggle = (
    instrument: ITestPlanInstrument,
    partition: IInstrumentPartition
  ) => {
    const instrumentPartitions = this.state.instrumentPartitions;
    const instrumentDetail = instrumentPartitions.find(
      (d) => d.id === instrument.id
    );
    const editedPartion = instrumentDetail.partitions.find(
      (d: any) => d.index === partition.index
    );
    editedPartion.isEdit = !editedPartion.isEdit;

    this.setState({
      instrumentPartitions,
      testplanFormData: {
        ...this.state.testplanFormData,
        instruments: instrumentPartitions
      }
    });
  };

  private editKeyedInToggle = (
    keyedIn: IKeyedInProperty,
    partition: IKeyedInPartition
  ) => {
    const keyedInPartitions = this.state.keyedInPartitions;
    const propertyDetail = keyedInPartitions.find((d) => d.id === keyedIn.id);
    const editedPartion = propertyDetail.partitions.find(
      (d: any) => d.index === partition.index
    );
    editedPartion.isEdit = !editedPartion.isEdit;

    this.setState({
      keyedInPartitions,
      testplanFormData: {
        ...this.state.testplanFormData,
        keyedInPartitions
      }
    });
  };
}

export default withRouter(Form);
